import React, { Fragment, useState, useRef, useEffect, useMemo } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { FileUpload } from 'primereact/fileupload';
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { AutoComplete } from 'primereact/autocomplete';
import { ToastService } from '@iamsoftware/react-hooks';
import { CommonService } from '../../../service/CommonService';
import { CustomerService } from '../../danh-muc/khach-hang/CustomerService';
import { useCustomerDialog } from '../../../hooks/useCustomerDialog';
import { Oauth2GoogleService } from '../../hop-dong/mau-hop-dong/Oauth2GoogleService';
import { GoogleService } from '../GoogleService';
import { Menu } from 'primereact/menu';
import { ScrollPanel } from 'primereact/scrollpanel';
import Draggable from 'react-draggable';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import { AgreementService } from 'src/service/AgreementService';
import { AgreementConfigService } from 'src/service/AgreementConfigService';

GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.min.mjs';

// Helper function to extract file extension from fileName and contentType
const extractFileExtension = (fileName?: string, contentType?: string): string => {
  // Try to extract extension from fileName
  if (fileName && typeof fileName === 'string') {
    const parts = fileName.split('.');
    if (parts.length > 1) {
      const ext = parts[parts.length - 1].toLowerCase();
      // Only use extension if it's not a number (like "123")
      if (ext && !/^\d+$/.test(ext)) {
        return ext;
      }
    }
  }

  // If no valid extension from fileName, try to get from contentType
  if (contentType) {
    if (contentType.includes('wordprocessingml')) return 'docx';
    if (contentType.includes('pdf')) return 'pdf';
    if (contentType.includes('spreadsheetml')) return 'xlsx';
    if (contentType.includes('presentationml')) return 'pptx';
    if (contentType.includes('msword')) return 'doc';
    if (contentType.includes('excel')) return 'xls';
    if (contentType.includes('powerpoint')) return 'ppt';
  }

  return 'docx';
};

type FormTypeOption = {
  label: string;
  value: string;
  enumCode?: string | null;
  raw?: any;
};

export const TaiLieu: React.FC = () => {
  const navigate = useNavigate();
  const { agreementId } = useParams();
  const [searchParams] = useSearchParams();
  const fileUploadRef = useRef<FileUpload>(null);
  const effectiveDateCalendarRef = useRef<any>(null);
  const expiryDateCalendarRef = useRef<any>(null);
  const [initializing, setInitializing] = useState<boolean>(false);
  const [isViewMode, setIsViewMode] = useState<boolean>(false);
  const [formData, setFormData] = useState({
    agreementName: '',
    agreementType: null,
    effectiveDate: null,
    expiryDate: null,
    agreementNo: '',
    agreementNoInt: null as number | null,
    description: '',
    isImportant: false,
    isUrgent: false
  });

  const [attachedFiles, setAttachedFiles] = useState<any[]>([]);
  const [mainFiles, setMainFiles] = useState<any[]>([]);
  const [isValid, setIsValid] = useState(false);
  const [isFileOptionsExpanded, setIsFileOptionsExpanded] = useState(false);
  const [isAttachedFilesExpanded, setIsAttachedFilesExpanded] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [googleFileId, setGoogleFileId] = useState<string>('');
  const [showGDoc, setShowGDoc] = useState<boolean>(false);
  const [displayEditor, setDisplayEditor] = useState<any>(null);
  const [showDeleteMainFileDialog, setShowDeleteMainFileDialog] = useState<boolean>(false);
  const [fileToDelete, setFileToDelete] = useState<any>(null);
  const [pseudoIdFormat, setPseudoIdFormat] = useState([])
  const [documentRecipients, setDocumentRecipients] = useState<any[]>([{
    party: null,
    taxCode: '',
    partyName: '',
    emailAddress: '',
    contactNumber: '',
    representativeName: '',
    identityCard: '',
    roleTypeId: ''
  }]);
  const [hasSigner, setHasSigner] = useState<boolean>(false);
  const [signerRoleIds, setSignerRoleIds] = useState<any[]>([]);
  const [roleOptions, setRoleOptions] = useState<any[]>([]);
  const [availableRoles, setAvailableRoles] = useState<any[]>([]);
  const [customers, setCustomers] = useState<any[]>([]);
  const [documentTypes, setDocumentTypes] = useState<any[]>([]);
  const [detailAgreementTypeOption, setDetailAgreementTypeOption] = useState<FormTypeOption | null>(null);
  const [documentTypeItems, setDocumentTypeItems] = useState<any[]>([]);
  const [documentTypeItemsLoading, setDocumentTypeItemsLoading] = useState<boolean>(false);
  const [documentTypeItemMeta, setDocumentTypeItemMeta] = useState<Record<string, { formType?: string | null; receivedDate?: Date | null }>>({});
  const [fileTypes, setFileTypes] = useState<any[]>([]);
  const [showRecipients, setShowRecipients] = useState<boolean>(false);
  const [showSignaturePlacement, setShowSignaturePlacement] = useState<boolean>(false);
  const [selectedSigner, setSelectedSigner] = useState<any>(null);
  const [signaturePositions, setSignaturePositions] = useState<any[]>([]);
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageCanvases, setPageCanvases] = useState<any[]>([]);
  const [canvasLoading, setCanvasLoading] = useState<boolean>(false);
  const canvasRefs = useRef<any[]>([]);
  const draggableRefs = useRef({} as any);
  const [filePreviews, setFilePreviews] = useState<{ [key: string]: string }>({});
  const [previewLoading, setPreviewLoading] = useState<{ [key: string]: boolean }>({});
  const [showFileViewer, setShowFileViewer] = useState<boolean>(false);
  const [fileOperationLoading, setFileOperationLoading] = useState<boolean>(false);
  const [viewerUrl, setViewerUrl] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [pdfScale, setPdfScale] = useState<number>(1.0);
  const [pdfPages, setPdfPages] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState<boolean>(false);
  const markDirty = () => setHasUnsavedChanges(true);
  const [showLeavePrompt, setShowLeavePrompt] = useState<boolean>(false);
  const [pendingHash, setPendingHash] = useState<string | null>(null);
  const [touchedFields, setTouchedFields] = useState<Record<string, boolean>>({});
  const [validationTriggered, setValidationTriggered] = useState(false);
  const [activeRecipientIndex, setActiveRecipientIndex] = useState<number | null>(null);
  const [party, setParty] = useState<any>(null);
  const formatSeq = (n: number) => (n < 10 ? `0${n}` : String(n));
  const normalizeLocationSeq = (positions: any[]) =>
    positions.map((pos, idx) => ({
      ...pos,
      locationSeqId: formatSeq(idx + 1)
    }));
  const mapAgreementTypes = (payload: any): any[] => {
    const source = Array.isArray(payload)
      ? payload
      : payload?.list ?? payload?.listData ?? [];
    if (!Array.isArray(source)) return [];
    return source
      .map((item: any) => {
        if (item?.label && item?.value) {
          return item;
        }
        const value =
          item?.agreementConfigureEnumId ||
          item?.agreementTypeId ||
          item?.value ||
          '';
        const label =
          item?.agreementConfigureName ||
          item?.agreementTypeName ||
          item?.description ||
          item?.label ||
          value;
        return {
          ...item,
          value,
          label
        };
      })
      .filter((item: any) => item?.value);
  };
  const resolveConfigItemSeq = (item: any, fallbackIndex?: number): number | null => {
    if (!item) return fallbackIndex !== undefined ? fallbackIndex + 1 : null;
    const seq =
      item.sequenceNum ??
      item.configSequenceNum ??
      item.agreementItemSeq ??
      item.agreementConfigureItemSeq ??
      item.id ??
      item.value ??
      (fallbackIndex !== undefined ? fallbackIndex + 1 : null);
    const parsed = Number(seq);
    return Number.isFinite(parsed) ? parsed : null;
  };
  const renderPage = (pdf: any, pageNumber: number) => {
    const totalPages = Number(pdf?.numPages) || 1;
    const requested = Number(pageNumber);
    const safePage = Math.min(Math.max(1, Number.isFinite(requested) ? requested : 1), totalPages);
    return pdf.getPage(safePage).then((page: any) => {
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      return page.render(renderContext).promise.then(() => canvas);
    });
  };

  const formTypeOptions = useMemo<FormTypeOption[]>(() => {
    if (Array.isArray(fileTypes) && fileTypes.length > 0) {
      return fileTypes.map((ft: any) => ({
        label: String(ft.description || ft.enumName || ft.enumId || ''),
        value: String(ft.enumId || ft.value || ft.enumCode || ''),
        enumCode: ft.enumCode ? String(ft.enumCode) : String(ft.enumId || ''),
        raw: ft
      })) as FormTypeOption[];
    }
    return [
      { label: 'Bản mềm', value: 'DIGITAL_COPY', enumCode: 'DIGITAL' },
      { label: 'Bản cứng', value: 'HARD_COPY', enumCode: 'HARD' }
    ] as FormTypeOption[];
  }, [fileTypes]);

  const normalizeFormTypeValue = (input?: string | null) => {
    if (!input) return null;
    const str = String(input);
    const option = formTypeOptions.find(
      (opt: any) => opt.value === str || opt.enumCode === str
    );
    if (option) return option.value;
    if (str === 'SOFT') return 'DIGITAL_COPY';
    if (str === 'HARD') return 'HARD_COPY';
    return str;
  };

  const loadPDFToCanvas = async (file: any) => {
    if (!file) return;

    setCanvasLoading(true);
    try {
      let arrayBuffer: ArrayBuffer;

      if (file.googleFileId) {
        // Mở quyền truy cập file trước khi tải PDF
        await GoogleService.openAnyoneView(agreementId, file.googleFileId);

        const blob = await Oauth2GoogleService.getPdf(file.googleFileId);
        arrayBuffer = await blob.arrayBuffer();
      } else if (file.file) {
        arrayBuffer = await file.file.arrayBuffer();
      } else {
        throw new Error('No file source available');
      }

      const loadingTask = getDocument({ data: arrayBuffer });
      console.log('loadPDFToCanvas: arrayBuffer size =', arrayBuffer.byteLength);

      loadingTask.promise.then((pdf: any) => {
        console.log('loadPDFToCanvas: PDF loaded, numPages =', pdf.numPages);
        setNumPages(pdf.numPages);

        const canvasPromises = [];
        for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
          canvasPromises.push(renderPage(pdf, pageNumber));
        }

        Promise.all(canvasPromises).then((canvases: any[]) => {
          console.log('loadPDFToCanvas: canvases rendered =', canvases.length);
          setPageCanvases(canvases);
          setCanvasLoading(false);
        });
      }, (reason: any) => {
        console.error('loadPDFToCanvas: PDF load error =', reason);
        setCanvasLoading(false);
      });
    } catch (error) {
      console.error('loadPDFToCanvas: Error =', error);
      setCanvasLoading(false);
    }
  };

  React.useEffect(() => {
    const beforeUnloadHandler = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', beforeUnloadHandler);
    return () => window.removeEventListener('beforeunload', beforeUnloadHandler);
  }, [hasUnsavedChanges]);

  React.useEffect(() => {
    let previousHash = window.location.hash;
    const onHashChange = () => {
      if (hasUnsavedChanges) {
        const target = window.location.hash;
        // revert ngay lập tức và mở dialog xác nhận
        window.location.hash = previousHash;
        setPendingHash(target);
        setShowLeavePrompt(true);
        return;
      }
      previousHash = window.location.hash;
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [hasUnsavedChanges]);

  const handleDrop = (event: any, pageIndex: number) => {
    const rect = canvasRefs.current[pageIndex]?.getBoundingClientRect();
    if (!rect) return;

    const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);
    const cursorX = event.clientX - rect.left;
    const cursorY = event.clientY - rect.top;

    const defaultWidth = 200;
    const defaultHeight = 65;
    const xMax = rect.width - defaultWidth;
    const yMax = rect.height - defaultHeight;
    const x = clamp(cursorX, 0, Math.max(0, xMax));
    const y = clamp(cursorY, 0, Math.max(0, yMax));

    const resolvePartyId = () => {
      if (!selectedSigner) return null as any;
      if (typeof selectedSigner === 'string' || typeof selectedSigner === 'number') return selectedSigner as any;
      return (selectedSigner as any).partyId || (selectedSigner as any).value || null;
    };
    const getPartyLabel = (pid: any) => {
      const r = documentRecipients.find((d: any) => d.partyId === pid);
      const raw = r?.party?.label || r?.partyName || (selectedSigner && (selectedSigner as any).label) || 'Chưa chọn người ký';
      const m = String(raw).match(/\]\s*-\s*(.+)$/);
      return m ? m[1] : String(raw);
    };
    const pid = resolvePartyId();
    const displayLabel = getPartyLabel(pid);

    // Tìm thông tin party đầy đủ từ documentRecipients
    const recipient = documentRecipients.find((r: any) =>
      r.partyId === pid ||
      r.party?.partyId === pid ||
      r.party?.value === pid
    );
    const partyInfo = recipient?.party || {};

    // Tạo signature position với đầy đủ thông tin party
    setSignaturePositions(prev => {
      const newPosition: any = {
        locationSeqId: formatSeq(prev.length + 1),
        x,
        y,
        pageIndex,
        widthPx: defaultWidth,
        heightPx: defaultHeight,
        fontSize: 12,
        signatureTypeEnumId: 'AgtDigitalVerified',
        label: displayLabel,
        partyName: recipient?.partyName || partyInfo.partyName || displayLabel,
        partyId: pid,
        roleTypeId: recipient?.roleTypeId || (selectedSigner && (selectedSigner as any).roleTypeId) || null
      };

      // Thêm toàn bộ thông tin party nếu có recipient
      if (recipient) {
        newPosition.taxCode = recipient.taxCode || partyInfo.partyTaxId || partyInfo.taxCode || '';
        newPosition.emailAddress = recipient.emailAddress || partyInfo.emailAddress || '';
        newPosition.contactNumber = recipient.contactNumber || partyInfo.contactNumber || '';
        newPosition.representativeName = recipient.representativeName || partyInfo.representativeName || '';
        newPosition.identityCard = recipient.identityCard || partyInfo.idValue || partyInfo.identityCard || '';
        newPosition.party = {
          ...partyInfo,
          value: partyInfo.value || partyInfo.partyId || pid,
          partyId: partyInfo.partyId || pid,
          label: partyInfo.label || recipient.partyName || displayLabel
        };
      }

      return normalizeLocationSeq([...prev, newPosition]);
    });
    markDirty();
  };

  const handleDragStop = (event: any, data: any, locationSeqId: string) => {
    const updatedElements = signaturePositions.map((element) => {
      if (element.locationSeqId === locationSeqId) {
        const canvas = canvasRefs.current[element.pageIndex];
        if (!canvas) return element;

        const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);
        const maxX = canvas.width - element.widthPx;
        const maxY = canvas.height - element.heightPx;
        const nx = clamp(data.x, 0, Math.max(0, maxX));
        const ny = clamp(data.y, 0, Math.max(0, maxY));


        return {
          ...element,
          x: nx,
          y: ny
        };
      }
      return element;
    });
    setSignaturePositions(normalizeLocationSeq(updatedElements));
    markDirty();
  };

  const removeSignaturePosition = (locationSeqId: string) => {
    setSignaturePositions(prev => normalizeLocationSeq(prev.filter(element => element.locationSeqId !== locationSeqId)));
    markDirty();
  };
  useEffect(() => {
    if (!selectedSigner) return;
    setSignaturePositions(prev => normalizeLocationSeq(prev.map(pos => {
      const updated = { ...pos } as any;
      if (!updated.partyId) updated.partyId = selectedSigner.partyId || selectedSigner.value || null;
      if (!updated.roleTypeId) updated.roleTypeId = selectedSigner.roleTypeId || null;
      if (!updated.partyName && selectedSigner.label) updated.partyName = selectedSigner.label;
      return updated;
    })));
  }, [selectedSigner]);

  // Sync signaturePositions with documentRecipients when recipient info changes
  // Also remove orphaned positions when their party is deleted
  useEffect(() => {
    if (!signaturePositions.length) return;

    // Get all valid partyIds from current recipients
    const validPartyIds = documentRecipients
      .map((r: any) => r.partyId || r.party?.partyId || r.party?.value)
      .filter(Boolean);

    setSignaturePositions(prev => {
      // Filter out orphaned positions (positions with partyId that no longer exists in recipients)
      const filtered = prev.filter(pos => {
        if (!pos.partyId) return true; // Keep positions without partyId
        return validPartyIds.includes(pos.partyId);
      });

      // Update remaining positions with new recipient info
      const updated = filtered.map(pos => {
        const recipient = documentRecipients.find((r: any) =>
          r.partyId === pos.partyId ||
          r.party?.partyId === pos.partyId ||
          r.party?.value === pos.partyId
        );
        if (!recipient) return pos;
        const partyInfo = recipient.party || {};
        const newLabel = partyInfo.label || recipient.partyName || pos.label;
        return {
          ...pos,
          label: newLabel,
          partyName: recipient.partyName || partyInfo.partyName || pos.partyName,
          taxCode: recipient.taxCode || partyInfo.partyTaxId || pos.taxCode,
          emailAddress: recipient.emailAddress || partyInfo.emailAddress || pos.emailAddress,
          contactNumber: recipient.contactNumber || partyInfo.contactNumber || pos.contactNumber,
          representativeName: recipient.representativeName || partyInfo.representativeName || pos.representativeName,
          identityCard: recipient.identityCard || partyInfo.idValue || pos.identityCard,
          roleTypeId: recipient.roleTypeId || pos.roleTypeId,
        };
      });

      return normalizeLocationSeq(updated);
    });
  }, [documentRecipients]);


  const generateFilePreview = async (file: any) => {
    const fileKey = `${file.name}-${file.googleFileId}`;
    const ext = (file.extension || '').toLowerCase();
    const type = (file.type || file.contentType || '').toLowerCase();
    const isGoogleDoc = type === 'application/vnd.google-apps.document';
    const isPreviewable = ext === 'pdf' || ext === 'docx' || ext === 'doc' || isGoogleDoc;

    if (filePreviews[fileKey]) {
      return filePreviews[fileKey];
    }

    setPreviewLoading(prev => ({ ...prev, [fileKey]: true }));

    try {
      if (isPreviewable) {
        if (!file.googleFileId) {
          setFilePreviews(prev => ({ ...prev, [fileKey]: null }));
          setPreviewLoading(prev => ({ ...prev, [fileKey]: false }));
          return null;
        }

        try {
          const blob = await Oauth2GoogleService.getPdf(file.googleFileId);
          const arrayBuffer = await blob.arrayBuffer();
          const loadingTask = getDocument({ data: arrayBuffer });
          const pdf = await loadingTask.promise;
          const page = await pdf.getPage(1);
          const scale = 1.2;
          const viewport = page.getViewport({ scale });
          const canvas = document.createElement('canvas');
          const canvasContext = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          const renderContext = {
            canvasContext,
            viewport,
          };
          await page.render(renderContext).promise;
          const dataUrl = canvas.toDataURL('image/png');
          setFilePreviews(prev => ({ ...prev, [fileKey]: dataUrl }));
          setPreviewLoading(prev => ({ ...prev, [fileKey]: false }));
          return dataUrl;
        } catch (pdfError) {
          setFilePreviews(prev => ({ ...prev, [fileKey]: null }));
          setPreviewLoading(prev => ({ ...prev, [fileKey]: false }));
          return null;
        }
      }
    } catch (error) {
      setPreviewLoading(prev => ({ ...prev, [fileKey]: false }));
    }

    return null;
  };

  useEffect(() => {
    const generatePreviews = async () => {
      for (const file of mainFiles) {
        const ext = (file.extension || '').toLowerCase();
        const type = (file.type || file.contentType || '').toLowerCase();
        const isGoogleDoc = type === 'application/vnd.google-apps.document';
        if (file.googleFileId && (ext === 'pdf' || ext === 'docx' || ext === 'doc' || isGoogleDoc)) {
          await generateFilePreview(file);
        }
      }
    };

    if (mainFiles.length > 0) {
      generatePreviews();
    }
  }, [mainFiles]);
  useEffect(() => {
    if (showSignaturePlacement && mainFiles.length > 0) {
      const mainFile = mainFiles.find(f => f.isMainFile) || mainFiles[0];
      console.log('Step3 loadPDFToCanvas mainFile:', mainFile);
      console.log('Step3 mainFiles:', mainFiles);
      loadPDFToCanvas(mainFile);
    }
  }, [showSignaturePlacement, mainFiles]);
  const breadcrumbItems = [
  ];
  React.useEffect(() => {
    CommonService.agreementRoleTypes?.().then((data: any) => {
      if (data?.listData) {
        const allRoles = data.listData.map((it: any) => ({ value: it.roleTypeId, label: it.description }));
        setRoleOptions(allRoles);
        setAvailableRoles(allRoles);
        const signerIds = data.listData
          .filter((it: any) => {
            const desc = String(it?.description || '').toLowerCase();
            return it?.isSigner === 'Y' || /ký|sign/.test(desc) || /bên\s*[ab]/.test(desc);
          })
          .map((it: any) => it.roleTypeId);
        setSignerRoleIds(signerIds);
      }
    }).catch(() => { });

    CustomerService.find('').then((data: any) => {
      if (data?.listData) setCustomers(data.listData.map((item: any) => {
        delete item.disabled;
        return { ...item, value: item.partyId, label: `[${item.pseudoId}] - ${item.partyName}` };
      }));
    }).catch(() => { });

    CommonService.getAgreementType().then((data: any) => {
      const mappedTypes = mapAgreementTypes(data);
      setDocumentTypes(mappedTypes);
    }).catch(() => { });

  }, []);

  useEffect(() => {
    if (detailAgreementTypeOption && detailAgreementTypeOption.value) {
      setDocumentTypes(prev => {
        const exists = prev.some(item => item.value === detailAgreementTypeOption.value);
        if (exists) return prev;
        return [...prev, detailAgreementTypeOption];
      });
    }
  }, [detailAgreementTypeOption]);

  useEffect(() => {
    if (!formData.agreementType) {
      setDocumentTypeItems([]);
      return;
    }
    const selectedType = documentTypes.find((item: any) => item.value === formData.agreementType);
    if (!selectedType) {
      setDocumentTypeItems([]);
      return;
    }
    const configId =
      selectedType.agreementPartyTypeConfId ||
      selectedType.agreementTypeConfId ||
      selectedType.id ||
      selectedType.value;
    if (!configId) {
      setDocumentTypeItems([]);
      return;
    }
    let ignore = false;
    setDocumentTypeItemsLoading(true);
    AgreementConfigService.get(String(configId))
      .then((res: any) => {
        if (ignore) return;
        if (res?.success === 'Y') {
          setDocumentTypeItems(Array.isArray(res?.items) ? res.items : []);
        } else {
          setDocumentTypeItems([]);
          ToastService.error(res?.error || 'Không thể tải cấu hình loại tài liệu');
        }
      })
      .catch((error: any) => {
        if (ignore) return;
        setDocumentTypeItems([]);
        ToastService.error(error?.message || 'Không thể tải cấu hình loại tài liệu');
      })
      .finally(() => {
        if (!ignore) {
          setDocumentTypeItemsLoading(false);
        }
      });
    return () => {
      ignore = true;
    };
  }, [documentTypes, formData.agreementType]);

  useEffect(() => {
    if (!Array.isArray(documentTypeItems) || documentTypeItems.length === 0) {
      setDocumentTypeItemMeta({});
      return;
    }
    setDocumentTypeItemMeta(prev => {
      const next: Record<string, { formType?: string | null; receivedDate?: Date | null }> = {};
      documentTypeItems.forEach((item: any, idx: number) => {
        const seq = resolveConfigItemSeq(item, idx);
        if (!seq) return;
        const seqKey = String(seq);
        const prevMeta = prev[seqKey] || {};
        const existingFile = attachedFiles.find((f: any) => Number(f.sequenceNum ?? f.configSequenceNum) === Number(seq));
        const fileFormType = existingFile ? normalizeFormTypeValue(existingFile.agreementFormTypeEnumId) : null;
        const fileDate = existingFile?.agreementFormDate ? new Date(existingFile.agreementFormDate) : null;
        next[seqKey] = {
          formType: normalizeFormTypeValue(prevMeta.formType ?? fileFormType ?? null),
          receivedDate: prevMeta.receivedDate ?? fileDate ?? null
        };
      });
      return next;
    });
  }, [documentTypeItems, attachedFiles, formTypeOptions]);

  useEffect(() => {
    CommonService.getFileTypes()
      .then((res: any) => {
        if (res?.listData && Array.isArray(res.listData)) {
          setFileTypes(res.listData);
        } else if (Array.isArray(res?.list)) {
          setFileTypes(res.list);
        } else if (Array.isArray(res)) {
          setFileTypes(res);
        } else {
          setFileTypes([]);
        }
      })
      .catch((error: any) => {
        console.error('Error loading file types:', error);
        setFileTypes([]);
      });
  }, []);

  const getFileTypeName = (item: any): string => {
    if (!item) return 'Không có mô tả';

    const fileTypeId = item.fileTypeEnumId || item.fileTypeId;
    if (!fileTypeId || fileTypes.length === 0) return item.description || 'Không có mô tả';

    const fileType = fileTypes.find((ft: any) => ft.enumId === fileTypeId || ft.enumCode === fileTypeId);
    return fileType?.description || item.description || 'Không có mô tả';
  };

  const isSignerRole = (roleTypeId: any) => signerRoleIds.includes(roleTypeId);

  const getRoleOptionsForRow = (rowIndex: number) => {
    const selected = documentRecipients[rowIndex]?.roleTypeId;
    const takenIds = documentRecipients
      .map((r, i) => (i === rowIndex ? null : r.roleTypeId))
      .filter((v: any) => v);
    const filtered = roleOptions.filter((o: any) => !takenIds.includes(o.value));
    if (selected && !filtered.some((o: any) => o.value === selected)) {
      const sel = roleOptions.find((o: any) => o.value === selected);
      return sel ? [sel, ...filtered] : filtered;
    }
    return filtered;
  };

  const getCustomerSuggestionsForRow = (rowIndex: number) => {
    const takenPartyIds = documentRecipients
      .map((r, i) => (i === rowIndex ? null : r.party?.value || r.party?.partyId))
      .filter((v: any) => v);
    return customers.filter((c: any) => !takenPartyIds.includes(c.value));
  };

  const addRecipient = () => {
    setDocumentRecipients(prev => [...prev, {
      party: null,
      taxCode: '',
      partyName: '',
      emailAddress: '',
      contactNumber: '',
      representativeName: '',
      identityCard: '',
      roleTypeId: ''
    }]);
  };
  const removeRecipient = (idx: number) => {
    const removed = documentRecipients[idx];
    const next = documentRecipients.filter((_, i) => i !== idx);
    setDocumentRecipients(next);
    if (removed?.roleTypeId) {
      const opt = roleOptions.find((o: any) => o.value === removed.roleTypeId);
      if (opt && !availableRoles.some((o: any) => o.value === opt.value)) {
        setAvailableRoles(prev => [...prev, opt]);
      }
    }
    setHasSigner(next.some(r => isSignerRole(r.roleTypeId)));
  };
  const handleRecipientChange = async (idx: number, field: string, value: any) => {
    let data = [...documentRecipients];
    const oldPartyId = data[idx]?.party?.partyId || data[idx]?.party?.value || data[idx]?.partyId;
    data[idx][field] = value;
    if (field === 'party') {
      data[idx].partyId = value?.partyId || value?.value || null;
    }

    if (data.length > roleOptions.length) {
      data = data.slice(0, roleOptions.length);
    }
    if (field === 'party' && oldPartyId) {
      setSignaturePositions(prev => normalizeLocationSeq(prev.filter(pos => pos.partyId !== oldPartyId)));
    }
    if (field === 'party' && value?.partyId) {
      const duplicateIdx = data.findIndex((r, i) => i !== idx && (r.party?.value === value.partyId || r.party?.partyId === value.partyId));
      if (duplicateIdx !== -1) {
        ToastService.error('Đối tượng này đã được chọn ở dòng khác');
        data[idx].party = null;
        setDocumentRecipients(data);
        return;
      }
      try {
        const customer = await CustomerService.get(value.partyId);
        data[idx].taxCode = customer.partyTaxId || '';
        data[idx].partyName = customer.partyName || '';
        data[idx].emailAddress = customer.emailAddress || '';
        data[idx].contactNumber = customer.contactNumber || '';
        data[idx].representativeName = customer.representativeName || '';
        data[idx].identityCard = customer.idValue || '';
      } catch (e) {
      }
    }

    setDocumentRecipients(data);
    setHasSigner(data.some(r => isSignerRole(r.roleTypeId)));
  };
  const searchCustomers = (event: any) => {
    CustomerService.find(event.query).then((data: any) => {
      if (data?.listData) {
        const mapped = data.listData.map((item: any) => {
          delete item.disabled;
          return { ...item, value: item.partyId, label: `[${item.pseudoId}] - ${item.partyName}` };
        });
        setCustomers(mapped);
      }
    }).catch(() => { });
  };

  const customerDialog = useCustomerDialog({
    service: CustomerService,
    requireTaxCode: true,
    async onAfterCreate(resp: any) {
      setParty(resp.partyId);
      const customerData = await CustomerService.find('');
      const newCustomers = (customerData.listData || []).map((customer: any) => {
        delete customer.disabled;
        const label = `[${customer.pseudoId}] - ${customer.partyName}`;
        return { ...customer, value: customer.partyId, label };
      });
      setCustomers(newCustomers);
      const newCustomer = newCustomers.find((customer: any) => customer.partyId === resp.partyId);
      if (newCustomer && activeRecipientIndex !== null) {
        await handleRecipientChange(activeRecipientIndex, 'party', {
          value: newCustomer.partyId,
          partyId: newCustomer.partyId,
          label: newCustomer.label
        });
      }
    }
  });

  const createCustomer = (idx: number) => {
    setActiveRecipientIndex(idx);
    customerDialog.create({ partyTypeEnumId: 'PtyPerson' });
  };

  const validateRequiredAttachedFiles = (): boolean => {
    if (isViewMode) return true;
    if (!Array.isArray(documentTypeItems) || documentTypeItems.length === 0) {
      return true; // Không có config items thì không cần check
    }

    const requiredItems = documentTypeItems.filter((item: any) => {
      const flag = item?.isRequire ?? item?.isRequired ?? item?.required;
      return flag === 'Y' || flag === true;
    });

    if (requiredItems.length === 0) {
      return true; // Không có item bắt buộc
    }

    const missingDescriptions: string[] = [];
    requiredItems.forEach((item: any, idx: number) => {
      const seq = resolveConfigItemSeq(item, idx);
      if (!seq) return;
      const seqKey = String(seq);
      const hasFile = attachedFiles.some((file: any) => {
        const fileSeq = file?.sequenceNum ?? file?.configSequenceNum;
        return Number(fileSeq) === Number(seq);
      });
      if (!hasFile) {
        const desc = item?.description || item?.fileTypeName || `Hạng mục #${seq}`;
        missingDescriptions.push(desc);
      }
    });

    if (missingDescriptions.length > 0) {
      ToastService.error(`Vui lòng tải lên các tệp đính kèm bắt buộc: ${missingDescriptions.join(', ')}`);
      return false;
    }

    return true;
  };

  const validateRecipients = (): boolean => {
    if (isViewMode) return true;
    if (!validateRequiredAttachedFiles()) {
      return false;
    }

    let checker = true;
    let errorMessage = '';

    for (let i = 0; i < documentRecipients.length; i++) {
      const item = documentRecipients[i];

      if (!item.party?.label) {
        checker = false;
        errorMessage = 'Chưa chọn đối tượng ký';
        break;
      }

      if (!item.emailAddress) {
        checker = false;
        errorMessage = `Chưa nhập địa chỉ email cho ${item.party?.label}`;
        break;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(item.emailAddress)) {
        checker = false;
        errorMessage = `Địa chỉ email của ${item.party?.label} chưa nhập đúng định dạng`;
        break;
      }

      if (!item.roleTypeId) {
        checker = false;
        errorMessage = `Chưa chọn vai trò người ký cho ${item.party?.label}`;
        break;
      }

      const trimmedtaxCode = item.taxCode?.trim() || '';
      if (trimmedtaxCode.length > 0 && ![10, 12, 13].includes(trimmedtaxCode.length)) {
        checker = false;
        errorMessage = `Mã số thuế của ${item.party?.label} phải có 10, 12 hoặc 13 số`;
        break;
      }

      const trimmedContactNumber = item.contactNumber?.trim() || '';
      if (trimmedContactNumber.length > 0 && trimmedContactNumber.length !== 10) {
        checker = false;
        errorMessage = `Số điện thoại của ${item.party?.label} phải có đúng 10 số`;
        break;
      }

      const trimmedIdentityCard = item.identityCard?.trim() || '';
      if (trimmedIdentityCard.length > 0 && ![9, 12].includes(trimmedIdentityCard.length)) {
        checker = false;
        errorMessage = `CCCD/CMND của ${item.party?.label} phải có 9 hoặc 12 số`;
        break;
      }
    }

    if (!checker && errorMessage) {
      ToastService.error(errorMessage);
    }

    return checker;
  };

  useEffect(() => {
    const loadDetail = async () => {
      if (!agreementId) return;
      try {
        const res = await AgreementService.getDetail(agreementId as string);
        if (res && res.success === 'Y') {
          const ag = res.agreement || {};

          const draftStatuses = ['AGT_DRAFT', 'AGT_INIT_DRAFT'];
          const isDraft = draftStatuses.includes(ag.statusId);
          const modeParam = searchParams.get('mode');
          const shouldViewMode = modeParam === 'view' || !isDraft;
          setIsViewMode(shouldViewMode);

          const agreementConfigureEnumId = ag.agreementConfigureEnumId || null;
          setFormData(prev => ({
            ...prev,
            agreementName: ag.agreementName || '',
            agreementConfigureEnumId: agreementConfigureEnumId,
            agreementType: agreementConfigureEnumId,
            agreementNo: ag.agreementNo || '',
            agreementNoInt: typeof ag.agreementNoInt === 'number' ? ag.agreementNoInt : null,
            description: ag.description || '',
            effectiveDate: ag.fromDate ? new Date(ag.fromDate) : null,
            expiryDate: ag.thruDate ? new Date(ag.thruDate) : null,
            isImportant: ag.isImportantInd === 'Y' || ag.isImportant === 'Y',
            isUrgent: ag.isUrgentInd === 'Y' || ag.isUrgent === 'Y',
          }));
          if (agreementConfigureEnumId) {
            const agreementTypeLabel = ag.agreementConfigureName || ag.agreementTypeName || '';
            setDetailAgreementTypeOption({
              label: agreementTypeLabel || agreementConfigureEnumId,
              value: agreementConfigureEnumId,
              enumCode: agreementConfigureEnumId
            });
          } else {
            setDetailAgreementTypeOption(null);
          }
          setTouchedFields({});
          setValidationTriggered(false);

          const mappedMain = (res.mainFiles || []).map((f: any) => {
            const fileId = f.fileId || null;
            return {
              agreementContentId: f.agreementContentId || undefined,
              name: f.fileName,
              size: 0,
              type: f.contentType,
              file: undefined,
              extension: extractFileExtension(f.fileName, f.contentType),
              googleFileId: fileId,
              fileId: fileId,
              id: fileId,
              googleFileUrl: f.contentLocation,
              contentLocation: f.contentLocation,
              isMainFile: true
            };
          });
          const mappedAttached = (res.attachmentFiles || []).map((f: any) => {
            const seqNum = f.sequenceNum ?? f.configSequenceNum ?? f.agreementItemSeq ?? null;
            const normalizedSeq = seqNum !== null && seqNum !== undefined ? Number(seqNum) : null;
            const fileId = f.fileId || null;
            return {
              agreementContentId: f.agreementContentId || undefined,
              name: f.fileName,
              size: 0,
              type: f.contentType,
              file: undefined,
              extension: extractFileExtension(f.fileName, f.contentType),
              googleFileId: fileId,
              fileId: fileId,
              id: fileId,
              googleFileUrl: f.contentLocation,
              contentLocation: f.contentLocation,
              isMainFile: false,
              sequenceNum: normalizedSeq,
              configSequenceNum: normalizedSeq,
              agreementFormTypeEnumId: f.agreementFormTypeEnumId || null,
              agreementFormDate: f.agreementFormDate || null
            };
          });
          setMainFiles(mappedMain);
          setAttachedFiles(mappedAttached);
          const apiRecipients = res.agreementParties || res.recipients || res.documentRecipients || res.parties || [];
          if (Array.isArray(apiRecipients) && apiRecipients.length > 0) {
            let normalized = apiRecipients.map((r: any) => ({
              party: r.party || (r.partyId ? { value: r.partyId, partyId: r.partyId, label: r.partyName || r.pseudoId || r.partyId } : null),
              partyId: r.partyId,
              taxCode: r.partyTaxId || r.taxCode || '',
              partyName: r.partyName || '',
              emailAddress: r.emailAddress || r.email || '',
              contactNumber: r.contactNumber || r.phone || '',
              representativeName: r.representativeName || r.fullName || '',
              identityCard: r.identityCard || r.idValue || '',
              roleTypeId: r.roleTypeId || r.role || ''
            }));
            try {
              const enrichPromises = normalized.map(async (rec: any) => {
                if (!rec.partyId) return rec;
                try {
                  const customer = await CustomerService.get(rec.partyId);
                  return {
                    ...rec,
                    taxCode: customer.partyTaxId ?? rec.taxCode,
                    partyName: customer.partyName ?? rec.partyName,
                    emailAddress: customer.emailAddress ?? rec.emailAddress,
                    contactNumber: customer.contactNumber ?? rec.contactNumber,
                    representativeName: customer.representativeName ?? rec.representativeName,
                    identityCard: customer.idValue ?? rec.identityCard,
                    party: { value: rec.partyId, partyId: rec.partyId, label: `[${customer.pseudoId}] - ${customer.partyName}` }
                  };
                } catch { return rec; }
              });
              normalized = await Promise.all(enrichPromises);
            } catch { /* ignore enrich errors */ }
            const finalized = normalized.map((rec: any) => {
              const label = rec.party?.label || (rec.partyName ? rec.partyName : rec.partyId);
              return {
                ...rec,
                party: rec.party && typeof rec.party === 'object'
                  ? { value: rec.party.value || rec.party.partyId || rec.partyId, partyId: rec.party.partyId || rec.partyId, label }
                  : (rec.partyId ? { value: rec.partyId, partyId: rec.partyId, label } : null)
              };
            });
            setDocumentRecipients(finalized);
            var recipientListForPositions = finalized;
          }

          const apiSigners = res.signers || [];
          if ((!apiRecipients || apiRecipients.length === 0) && Array.isArray(apiSigners) && apiSigners.length > 0) {
            try {
              const mapped = await Promise.all(apiSigners.map(async (s: any) => {
                let base = { partyId: s.partyId, roleTypeId: s.roleTypeId } as any;
                try {
                  const customer = await CustomerService.get(s.partyId);
                  base.party = { partyId: s.partyId, label: `[${customer.pseudoId}] - ${customer.partyName}` };
                  base.taxCode = customer.partyTaxId || '';
                  base.partyName = customer.partyName || '';
                  base.emailAddress = customer.emailAddress || '';
                  base.contactNumber = customer.contactNumber || '';
                  base.representativeName = customer.representativeName || '';
                  base.identityCard = customer.idValue || '';
                } catch {
                  base.party = { partyId: s.partyId, label: s.partyName || s.partyId };
                  base.taxCode = '';
                  base.partyName = s.partyName || '';
                  base.emailAddress = '';
                  base.contactNumber = '';
                  base.representativeName = '';
                  base.identityCard = '';
                }
                return base;
              }));
              setDocumentRecipients(mapped);
              if (!selectedSigner && mapped.length > 0) setSelectedSigner({ value: mapped[0].partyId, partyId: mapped[0].partyId, roleTypeId: mapped[0].roleTypeId, label: mapped[0].party?.label || mapped[0].partyName } as any);
            } catch {/* ignore */ }
          }
          const agreementPartiesStatus: Record<string, string> = {};
          (res?.agreementParties || res?.agreement_parties || []).forEach((p: any) => {
            if (p?.partyId) {
              agreementPartiesStatus[String(p.partyId)] = p.statusId || p.status_id || '';
            }
          });

          const apiPositions = res.signaturePositions || res.signature_positions || [];
          let mappedPositions: any[] = [];
          if (Array.isArray(apiPositions) && apiPositions.length > 0) {
            const recipientsRef = (typeof recipientListForPositions !== 'undefined' && Array.isArray(recipientListForPositions) && recipientListForPositions.length > 0)
              ? recipientListForPositions
              : documentRecipients;
            const getPartyLabel = (pid: any) => {
              const r = Array.isArray(recipientsRef) ? recipientsRef.find((x: any) => x.partyId === pid) : undefined;
              const raw = r?.party?.label || r?.partyName || '';
              const m = String(raw).match(/\]\s*-\s*(.+)$/);
              return m ? m[1] : String(raw);
            };
            mappedPositions = apiPositions
              .map((p: any, idx: number) => {
                const pid = p.partyId || p.party_id || null;
                const partyLabel = p.partyName || p.party_name || getPartyLabel(pid);
                return {
                  locationSeqId: p.locationSeqId || p.location_seq_id || String(idx + 1).padStart(2, '0'),
                  pageIndex: p.pageNumber ? Number(p.pageNumber) - 1 : Number(p.pageIndex ?? p.page_index ?? 0),
                  x: Number(p.ulx ?? p.x ?? 0),
                  y: Number(p.uly ?? p.y ?? 0),
                  widthPx: Number(p.widthPx ?? p.width_px ?? p.width ?? 200),
                  heightPx: Number(p.heightPx ?? p.height_px ?? p.height ?? 65),
                  fontSize: Number(p.fontSize ?? p.font_size ?? 12),
                  partyId: pid,
                  roleTypeId: p.roleTypeId || p.role_type_id || null,
                  partyName: partyLabel,
                  label: partyLabel,
                  signatureTypeEnumId: p.signatureTypeEnumId || p.signature_type_enum_id || 'AgtDigitalVerified'
                };
              })
              .filter((pos: any) => {
                if (!pos.partyId) return true;
                const status = agreementPartiesStatus[String(pos.partyId)];
                return status !== 'AGT_PTY_SIGNED';
              });
          }
          if (mappedPositions.length > 0) setSignaturePositions(normalizeLocationSeq(mappedPositions));
        } else {
          ToastService.error(res?.message || 'Không tải được thông tin tài liệu');
        }
      } catch (e) {
        ToastService.error(e?.message || 'Lỗi khi tải thông tin tài liệu');
      } finally { }
    };
    loadDetail();
  }, [agreementId]);
  const validateForm = () => {
    if (isViewMode) return true;
    let valid = true;
    let errorMessage = '';

    // Validate tên tài liệu
    if (!formData.agreementName || formData.agreementName.trim() === '') {
      valid = false;
      errorMessage = 'Vui lòng nhập Tên tài liệu';
    }
    // Validate loại tài liệu
    else if (formData.agreementType === null) {
      valid = false;
      errorMessage = 'Vui lòng chọn Loại tài liệu';
    }
    else if (mainFiles.length === 0) {
      valid = false;
      errorMessage = 'Vui lòng tải lên tệp tài liệu trước khi ký';
    }
    else if (!formData.agreementNo || formData.agreementNo.trim() === '') {
      valid = false;
      errorMessage = 'Vui lòng nhập Mã tài liệu';
    }
    else if (formData.effectiveDate) {
      const now = new Date();
      const effective = new Date(formData.effectiveDate as any);
      const nowPlusOneMinute = new Date(now.getTime() + 60 * 1000); // Cho phép sai số 1 phút

      if (effective.getTime() > nowPlusOneMinute.getTime()) {
        valid = false;
        errorMessage = 'Ngày hiệu lực không được lớn hơn thời điểm hiện tại';
      }
    }

    if (valid && formData.expiryDate) {
      const now = new Date();
      const expiry = new Date(formData.expiryDate as any);

      if (formData.effectiveDate) {
        const effective = new Date(formData.effectiveDate as any);
        const effectivePlusOneHour = new Date(effective.getTime() + 60 * 60 * 1000);
        const nowPlusOneHour = new Date(now.getTime() + 60 * 60 * 1000);
        const minExpiryDate = new Date(Math.max(effectivePlusOneHour.getTime(), nowPlusOneHour.getTime()));
        if (expiry.getTime() <= minExpiryDate.getTime()) {
          valid = false;
          errorMessage = 'Ngày hết hiệu lực phải lớn hơn ngày hiệu lực ít nhất 1 giờ';
        }
      } else {
        const nowPlusOneHour = new Date(now.getTime() + 60 * 60 * 1000);
        if (expiry.getTime() <= nowPlusOneHour.getTime()) {
          valid = false;
          errorMessage = 'Ngày hết hiệu lực phải lớn hơn thời điểm hiện tại ít nhất 1 giờ';
        }
      }
    }
    if (valid && Array.isArray(documentTypeItems) && documentTypeItems.length > 0) {
      const missingMethod: string[] = [];
      documentTypeItems.forEach((item: any, idx: number) => {
        const seq = resolveConfigItemSeq(item, idx);
        if (!seq) return;
        const seqKey = String(seq);

        const isRequired = item?.isRequire === 'Y' || item?.isRequired === true || item?.required === true;
        const hasFile = attachedFiles.some((f: any) => {
          const fileSeq = f?.sequenceNum ?? f?.configSequenceNum;
          return Number(fileSeq) === Number(seq);
        });

        // Bỏ qua nếu không bắt buộc và chưa có file
        if (!isRequired && !hasFile) return;

        const meta = documentTypeItemMeta[seqKey];
        if (!meta?.formType) {
          const desc = item?.description || item?.fileTypeName || `Hạng mục #${seq}`;
          missingMethod.push(desc);
        }
      });

      if (missingMethod.length > 0) {
        valid = false;
        errorMessage = `Vui lòng chọn Hình thức cho: ${missingMethod.join(', ')}`;
      }
    }

    if (valid && Array.isArray(documentTypeItems) && documentTypeItems.length > 0) {
      const missingDateItems: string[] = [];
      documentTypeItems.forEach((item: any, idx: number) => {
        const seq = resolveConfigItemSeq(item, idx);
        if (!seq) return;
        const seqKey = String(seq);

        const meta = documentTypeItemMeta[seqKey];
        const file = attachedFiles.find((f: any) => {
          const fileSeq = f?.sequenceNum ?? f?.configSequenceNum;
          return Number(fileSeq) === Number(seq);
        });

        const normalizedFormType =
          meta?.formType ??
          (file?.agreementFormTypeEnumId ? normalizeFormTypeValue(file.agreementFormTypeEnumId) : null);
        if (normalizedFormType === 'ATTACH_SCAN') {
          const effectiveDateValue =
            meta?.receivedDate ??
            (file?.agreementFormDate ? new Date(file.agreementFormDate) : null);
          if (!effectiveDateValue) {
            const desc = item?.description || item?.fileTypeName || `Hạng mục #${seq}`;
            missingDateItems.push(desc);
          }
        }
      });
      if (missingDateItems.length > 0) {
        valid = false;
        errorMessage = `Vui lòng nhập Ngày nhận cho: ${missingDateItems.join(', ')}`;
      }
    }

    if (valid && Array.isArray(documentTypeItems) && documentTypeItems.length > 0) {
      const requiredItems = documentTypeItems.filter((item: any) => {
        const flag = item?.isRequire ?? item?.isRequired ?? item?.required;
        return flag === 'Y' || flag === true;
      });
      if (requiredItems.length > 0) {
        const missingDescriptions: string[] = [];
        requiredItems.forEach((item: any, idx: number) => {
          const seq = resolveConfigItemSeq(item, idx);
          if (!seq) return;
          const seqKey = String(seq);
          const hasFile = attachedFiles.some((file: any) => {
            const fileSeq = file?.sequenceNum ?? file?.configSequenceNum;
            return Number(fileSeq) === Number(seq);
          });
          if (!hasFile) {
            const desc = item?.description || item?.fileTypeName || `Hạng mục #${seq}`;
            missingDescriptions.push(desc);
          }
        });
        if (missingDescriptions.length > 0) {
          valid = false;
          errorMessage = `Vui lòng tải lên các tệp bắt buộc: ${missingDescriptions.join(', ')}`;
        }
      }
    }

    if (!valid && errorMessage) {
      ToastService.error(errorMessage);
    }

    setIsValid(valid);
    return valid;
  };

  const getEffectiveMaxDate = () => {
    return new Date(); // Ngày hiệu lực không được lớn hơn thời điểm hiện tại
  };

  const getExpiryMinDate = () => {
    const now = new Date();
    const minFromNow = new Date(now.getTime() + 60 * 60 * 1000);

    if (formData.effectiveDate) {
      const effective = new Date(formData.effectiveDate as any);
      const minFromEffective = new Date(effective.getTime() + 60 * 60 * 1000);
      return new Date(Math.max(minFromNow.getTime(), minFromEffective.getTime()));
    }
    return minFromNow;
  };

  const handleInputChange = (field: string, value: any, options?: { skipTouch?: boolean; skipAutoCode?: boolean }) => {
    let newData = { ...formData, [field]: value };

    if (field === 'agreementType' && formData.agreementType !== value) {
      setAttachedFiles(prev => prev.filter(f => f.sequenceNum === null || typeof f.sequenceNum === 'undefined'));
      setDocumentTypeItemMeta({});
      newData = { ...newData, agreementNo: '' };
    }

    setFormData(newData);

    if (field === 'agreementType' && formData.agreementType !== value && !options?.skipAutoCode) {
      generateDocumentCode(value);
    }

    if (!options?.skipTouch) {
      setTouchedFields(prev => ({ ...prev, [field]: true }));
    }

    markDirty();
  };

  const handleCheckboxChange = (field: 'isImportant' | 'isUrgent', checked: boolean) => {
    setFormData(prev => ({ ...prev, [field]: checked }));
    markDirty();
  };

  // Chỉ xóa trên client để cập nhật UI, không gọi server
  const handleRemoveLocalFile = (file: any) => {
    // Nếu là file chính, hiển thị dialog xác nhận
    if (file.isMainFile) {
      setFileToDelete(file);
      setShowDeleteMainFileDialog(true);
      return;
    }

    // Xóa file đính kèm trực tiếp
    const targetId = file.fileId || file.googleFileId || file.id || null;
    const matchFile = (candidate: any) => {
      const candidateId = candidate.fileId || candidate.googleFileId || candidate.id || null;
      return targetId && candidateId && targetId === candidateId;
    };

    setAttachedFiles(prev => prev.filter(f => !matchFile(f)));
    markDirty();
  };

  const confirmDeleteMainFile = () => {
    if (!fileToDelete) return;

    const targetId = fileToDelete.fileId || fileToDelete.googleFileId || fileToDelete.id || null;
    const matchFile = (candidate: any) => {
      const candidateId = candidate.fileId || candidate.googleFileId || candidate.id || null;
      return targetId && candidateId && targetId === candidateId;
    };

    setMainFiles(prev => prev.filter(f => !matchFile(f)));

    setDocumentRecipients([{
      party: null,
      taxCode: '',
      partyName: '',
      emailAddress: '',
      contactNumber: '',
      representativeName: '',
      identityCard: '',
      roleTypeId: ''
    }]);

    setSignaturePositions([]);

    markDirty();
    setShowDeleteMainFileDialog(false);
    setFileToDelete(null);
  };
  const handleFileUpload = async (event: any) => {
    const files = event.files;
    if (files && files.length > 0) {
      setFileOperationLoading(true);
      const validFiles: any[] = [];
      const invalidFiles: string[] = [];

      Array.from(files).forEach((file: any) => {
        const extension = getFileExtension(file.name);
        const allowedExtensions = ['pdf', 'docx', 'doc'];

        if (allowedExtensions.includes(extension)) {
          validFiles.push(file);
        } else {
          invalidFiles.push(file.name);
        }
      });

      if (invalidFiles.length > 0) {
        ToastService.error(`Các file sau không đúng định dạng: ${invalidFiles.join(', ')}. Chỉ hỗ trợ PDF, DOCX, DOC.`);
      }

      if (mainFiles.length > 0) {
        ToastService.error('Chỉ được phép có 1 file trong TỆP TÀI LIỆU. Vui lòng xóa file hiện tại trước khi thêm file mới.');
        return;
      }

      for (const file of validFiles) {
        try {
          const mapped = await uploadFileToGoogle(file, { isMain: true });
          if (mapped) {
            setMainFiles([mapped]);
          } else {
            ToastService.error(`Không thể upload ${file.name}`);
          }
        } catch (e) {
          ToastService.error(`Lỗi khi upload ${file.name}`);
        }

      }
      markDirty();
      setFileOperationLoading(false);
    }
  };

  const getFileExtension = (filename: string): string => {
    return filename.split('.').pop()?.toLowerCase() || '';
  };

  const uploadFileToGoogle = async (file: File, options: { isMain: boolean; sequenceNum?: number | null }) => {
    const isMain = options.isMain;
    const seq = options.sequenceNum;
    const mapResponse = (res: any) => {
      if (!res) return null;
      const fileId = res.fileId || null;
      return {
        name: res.fileName || file.name,
        size: (file as any).size,
        type: (file as any).type,
        file: undefined,
        extension: res.format || getFileExtension(file.name),
        googleFileId: fileId,
        fileId: fileId,
        id: fileId,
        googleFileUrl: res.fileUrl,
        isMainFile: isMain,
        sequenceNum: seq ?? undefined,
        configSequenceNum: seq ?? undefined
      };
    };

    const res = await GoogleService.uploadFile(file);
    console.log('uploadFileToGoogle response:', res);
    if (res && (res.success === 'Y' || res.fileId)) {
      const mapped = mapResponse(res);
      console.log('uploadFileToGoogle mapped:', mapped);
      if (mapped) return mapped;
    }
    throw new Error(res?.errors || res?.error || 'Upload thất bại');
  };
  const getIconByExtension = (extOrType?: string): { icon: string; color: string } => {
    const e = (extOrType || '').toLowerCase();
    if (e === 'pdf') return { icon: 'pi pi-file-pdf', color: 'text-red-500' };
    if (
      e === 'doc' ||
      e === 'docx' ||
      e === 'application/vnd.google-apps.document' ||
      e === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      e === 'application/msword'
    )
      return { icon: 'pi pi-file-word', color: 'text-blue-500' };
    if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(e)) return { icon: 'pi pi-image', color: 'text-green-500' };
    if (['xlsx', 'xls', 'csv'].includes(e)) return { icon: 'pi pi-file-excel', color: 'text-green-600' };
    if (['ppt', 'pptx'].includes(e)) return { icon: 'pi pi-file', color: 'text-orange-500' };
    if (['zip', 'rar'].includes(e)) return { icon: 'pi pi-file-archive', color: 'text-yellow-600' };
    if (['txt', 'json', 'xml', 'html'].includes(e)) return { icon: 'pi pi-file', color: 'text-gray-600' };
    return { icon: 'pi pi-file', color: 'text-blue-500' };
  };

  const ensureMainFile = (files: any[]) => {
    if (files.length > 1) {
      return [files[0]];
    }
    return files;
  };

  const setMainFile = (idx: number) => {
    setMainFiles(prev => prev.map((f, i) => ({ ...f, isMainFile: i === idx })));
    markDirty();
  };

  const handleCreateGoogleFile = async () => {
    if (mainFiles.length > 0) {
      ToastService.error('Chỉ được phép có 1 file trong TỆP TÀI LIỆU. Vui lòng xóa file hiện tại trước khi tạo file mới.');
      return;
    }

    try {
      setFileOperationLoading(true);
      const res = await Oauth2GoogleService.create({ agreementId: agreementId, fileName: formData.agreementName || 'document' });
      if (res && res.fileId) {
        setGoogleFileId(res.fileId);
        setShowGDoc(true);
        setDisplayEditor({ fileId: res.fileId });
        markDirty();
      } else {
        ToastService.error('Không thể tạo file Google Doc');
      }
    } catch (e: any) {
      ToastService.error('Có lỗi xảy ra khi tạo file Google Doc');
    } finally {
      setFileOperationLoading(false);
    }
  }
  const handleComputerUpload = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.pdf,.docx,.doc';
    input.multiple = true;
    input.onchange = async (e: any) => {
      const files = Array.from(e.target.files);
      if (files.length > 0) {
        const validFiles: any[] = [];
        const invalidFiles: string[] = [];

        files.forEach((file: any) => {
          const extension = getFileExtension(file.name);
          const allowedExtensions = ['pdf', 'docx', 'doc'];

          if (allowedExtensions.includes(extension)) {
            validFiles.push(file);
          } else {
            invalidFiles.push(file.name);
          }
        });

        if (invalidFiles.length > 0) {
          ToastService.error(`Các file sau không đúng định dạng: ${invalidFiles.join(', ')}. Chỉ hỗ trợ PDF, DOCX, DOC.`);
        }

        if (mainFiles.length > 0) {
          ToastService.error('Chỉ được phép có 1 file trong TỆP TÀI LIỆU. Vui lòng xóa file hiện tại trước khi thêm file mới.');
          return;
        }

        setFileOperationLoading(true);
        for (const file of validFiles) {
          try {
            const mapped = await uploadFileToGoogle(file as any, { isMain: true });
            if (mapped) {
              setMainFiles([mapped]);
            } else {
              ToastService.error(`Không thể upload ${(file as any).name}`);
            }
          } catch (e: any) {
            const errorMsg = e?.response?.errors || `Lỗi khi upload ${(file as any).name}`;
            ToastService.error(errorMsg);
          }
        }
        setFileOperationLoading(false);
        markDirty();
      }
    };
    input.click();
  };

  const handleDocumentTypeItemUpload = (item: any, idx: number) => {
    if (isViewMode) return;
    const seq = resolveConfigItemSeq(item, idx);
    if (!seq) {
      ToastService.error('Không xác định được hạng mục file.');
      return;
    }
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.pdf,.doc,.docx';
    input.onchange = async (e: any) => {
      const file = e.target.files?.[0];
      if (!file) return;
      try {
        setFileOperationLoading(true);
        // Luôn upload file lên Google để có fileId
        const uploadedFile = await uploadFileToGoogle(file, { isMain: false, sequenceNum: seq });
        setAttachedFiles(prev => {
          const filtered = prev.filter(f => Number(f?.sequenceNum ?? f?.configSequenceNum) !== Number(seq));
          const normalFiles = filtered.filter(f => f.sequenceNum === null || typeof f.sequenceNum === 'undefined');
          const configFiles = filtered.filter(f => !(f.sequenceNum === null || typeof f.sequenceNum === 'undefined'));
          return [...configFiles, uploadedFile, ...normalFiles];
        });
        ToastService.success(`Đã gắn tệp cho hạng mục #${seq}`);
        markDirty();
      } catch (error: any) {
        ToastService.error(error?.message || 'Không thể tải tệp cho hạng mục');
      } finally {
        setFileOperationLoading(false);
      }
    };
    input.click();
  };

  const handleDocumentTypeItemMetaChange = (seqKey: string, field: 'formType' | 'receivedDate', value: any) => {
    const nextValue = field === 'formType' ? normalizeFormTypeValue(value) : value;
    setDocumentTypeItemMeta(prev => ({
      ...prev,
      [seqKey]: {
        ...prev[seqKey],
        [field]: nextValue
      }
    }));
    markDirty();
  };
  const handleViewFile = async (file: any) => {
    setSelectedFile(file);
    setShowFileViewer(true);
    setViewerUrl(null);
    setPdfScale(1.0);
    setCurrentPage(1);
    setPdfPages([]);


    try {
      if (file?.googleFileId) {
        // Mở quyền truy cập file trước khi tải PDF
        await GoogleService.openAnyoneView(agreementId, file.googleFileId);

        const blob = await Oauth2GoogleService.getPdf(file.googleFileId);
        const url = URL.createObjectURL(blob);
        setViewerUrl(url);

        try {
          const arrayBuffer = await blob.arrayBuffer();
          const loadingTask = getDocument({ data: arrayBuffer });
          const pdf = await loadingTask.promise;

          const pages = [];
          for (let i = 1; i <= pdf.numPages; i++) {
            const page = await pdf.getPage(i);
            const viewport = page.getViewport({ scale: 0.3 });
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            await page.render({
              canvasContext: context,
              viewport: viewport,
            }).promise;

            pages.push({
              pageNumber: i,
              thumbnail: canvas.toDataURL('image/png')
            });
          }

          setPdfPages(pages);
        } catch (pdfError) {
          console.error('Error loading PDF pages:', pdfError);
        }
      }
    } catch (error) {
      ToastService.error('Error opening viewer');
    }
  };

  const handleEditFile = async (file: any) => {
    if (!file.googleFileId) {
      ToastService.error('File này không thể chỉnh sửa');
      return;
    }

    try {
      const result = await GoogleService.openAnyoneView(agreementId, file.googleFileId);

      if (result && result.success === 'Y') {
        setDisplayEditor({ fileId: file.googleFileId, fileName: file.name });
      } else {
        ToastService.error(result?.error || 'Không thể mở quyền chỉnh sửa');
      }
    } catch (error) {
      ToastService.error('Có lỗi xảy ra khi mở chỉnh sửa');
    }
  };

  const handleCloseFile = async (file: any) => {
    if (!file.googleFileId) {
      ToastService.error('File này không thể đóng quyền');
      return;
    }

    try {
      await AgreementService.closeContent(agreementId, file.googleFileId);
    } catch (error) {
      ToastService.error('Có lỗi xảy ra khi đóng File');
    }
  };

  useEffect(() => {
    if (!displayEditor && selectedFile?.googleFileId) {
      AgreementService.closeContent(agreementId, selectedFile.googleFileId).catch(() => undefined);
    }
  }, [displayEditor, selectedFile, agreementId]);


  const handleDownloadFile = async (file: any) => {
    try {
      const fileId = file.googleFileId || file.fileId || file.id;
      if (!fileId) throw new Error('missing fileId');

      const blob = await Oauth2GoogleService.getMedia(fileId);
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;

      // Extract filename from blob (from Content-Disposition header) if available
      const blobFileName = (blob as any).fileName;

      // Priority: file.name > file.fileName > blobFileName > 'document'
      // Always use the name from the file being downloaded, not from mainFile
      const fileName = file.name || file.fileName || blobFileName || 'document';

      // Only add extension if filename doesn't already have one
      const hasExtension = fileName.includes('.') && /\.\w+$/.test(fileName);

      // Use extension from the file being downloaded
      const ext = (file.extension && !hasExtension ? ('.' + file.extension) : '') || '';

      const finalFileName = hasExtension ? fileName : (fileName + ext);

      link.download = finalFileName;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (e) {
      ToastService.error('Không thể tải xuống file này');
    }
  };

  const getFileMenuItems = (file: any) => {
    const allItems = [
      {
        label: 'Xem',
        icon: 'pi pi-eye',
        command: (e: any) => {
          e?.originalEvent?.stopPropagation?.();
          handleViewFile(file);
        }
      },
      {
        label: 'Chỉnh sửa',
        icon: 'pi pi-pencil',
        command: (e: any) => {
          e?.originalEvent?.stopPropagation?.();
          handleEditFile(file);
        },
        disabled: file.extension === 'pdf',
        hidden: isViewMode
      },
      {
        label: 'Tải xuống',
        icon: 'pi pi-download',
        command: (e: any) => {
          e?.originalEvent?.stopPropagation?.();
          handleDownloadFile(file);
        }
      },
      {
        separator: true,
        hidden: isViewMode
      },
      {
        label: 'Xóa',
        icon: 'pi pi-trash',
        command: (e: any) => {
          e?.originalEvent?.stopPropagation?.();
          handleRemoveLocalFile(file);
        },
        className: 'p-button-danger',
        hidden: isViewMode
      }
    ];
    return allItems.filter(item => !item.hidden);
  };

  const toggleAttachedFiles = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsAttachedFilesExpanded(!isAttachedFilesExpanded);
  };

  const generateDocumentCode = (agreementTypeOverride?: string | null) => {
    const agreementType = agreementTypeOverride ?? formData.agreementType;
    if (!agreementType) {
      ToastService.error('Vui lòng chọn Loại tài liệu trước');
      return;
    }
    // Lưu agreementType vào closure để đảm bảo giữ lại khi update formData
    const savedAgreementType = agreementType;
    AgreementService.generateDocumentCode(agreementType)
      .then((res: any) => {
        if (res && res.success === 'Y') {
          // Cập nhật agreementNo và agreementNoInt cùng lúc, đảm bảo giữ lại agreementType
          setFormData(prev => ({
            ...prev,
            agreementType: prev.agreementType || savedAgreementType, // Giữ lại agreementType nếu đã có, nếu không thì dùng savedAgreementType
            agreementNo: res.agreementNo,
            agreementNoInt: typeof res.agreementNoInt === 'number' ? res.agreementNoInt : null
          }));
        } else {
          ToastService.error(res?.error || 'Không tạo được mã tài liệu');
        }
      })
      .catch(() => {
        ToastService.error('Không tạo được mã tài liệu');
      });
  };

  const handleSubmit = async () => {
    if (!isViewMode) {
      setValidationTriggered(true);
      if (!validateForm()) {
        return;
      }
      if (!validateRequiredAttachedFiles()) {
        return;
      }
    }
    setShowRecipients(true);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const getCurrentStep = () => {
    if (showSignaturePlacement) return 3;
    if (showRecipients) return 2;
    return 1;
  };

  const renderStepIndicators = (expand: boolean) => {
    const currentStep = getCurrentStep();
    const connectorClass = expand ? 'flex-1 border-top-1' : 'border-top-1';
    const connectorStyle = {
      width: expand ? undefined : '80px',
      maxWidth: '120px',
      height: '2px',
      margin: '0 8px'
    } as React.CSSProperties;

    return (
      <div className={`flex align-items-center justify-content-center ${expand ? 'flex-1' : ''}`} style={{ gap: '12px' }}>
        {/* Step 1 */}
        <div className="flex align-items-center" style={{ gap: '8px' }}>
          <div
            className={`flex align-items-center justify-content-center border-circle ${currentStep >= 1 ? 'bg-blue-500 text-white' : 'border-2 border-gray-300 text-gray-400 bg-white'}`}
            style={{
              width: '32px',
              height: '32px',
              fontSize: '14px',
              fontWeight: '600',
              minWidth: '32px'
            }}
          >
            1
          </div>
          <span
            className={`text-sm font-medium ${currentStep >= 1 ? 'text-gray-900' : 'text-gray-400'}`}
            style={{ whiteSpace: 'nowrap' }}
          >
            Tải lên tài liệu
          </span>
        </div>

        {/* Connector Line */}
        <div
          className={`${connectorClass} ${currentStep >= 2 ? 'border-blue-500' : 'border-gray-300'}`}
          style={connectorStyle}
        ></div>

        {/* Step 2 */}
        <div className="flex align-items-center" style={{ gap: '8px' }}>
          <div
            className={`flex align-items-center justify-content-center border-circle ${currentStep >= 2 ? 'bg-blue-500 text-white' : 'border-2 border-gray-300 text-gray-400 bg-white'}`}
            style={{
              width: '32px',
              height: '32px',
              fontSize: '14px',
              fontWeight: '600',
              minWidth: '32px'
            }}
          >
            2
          </div>
          <span
            className={`text-sm font-medium ${currentStep >= 2 ? 'text-gray-900' : 'text-gray-400'}`}
            style={{ whiteSpace: 'nowrap' }}
          >
            Thiết lập người nhận
          </span>
        </div>

        {/* Connector Line */}
        <div
          className={`${connectorClass} ${currentStep >= 3 ? 'border-blue-500' : 'border-gray-300'}`}
          style={connectorStyle}
        ></div>

        {/* Step 3 */}
        <div className="flex align-items-center" style={{ gap: '8px' }}>
          <div
            className={`flex align-items-center justify-content-center border-circle ${currentStep >= 3 ? 'bg-blue-500 text-white' : 'border-2 border-gray-300 text-gray-400 bg-white'}`}
            style={{
              width: '32px',
              height: '32px',
              fontSize: '14px',
              fontWeight: '600',
              minWidth: '32px'
            }}
          >
            3
          </div>
          <span
            className={`text-sm font-medium ${currentStep >= 3 ? 'text-gray-900' : 'text-gray-400'}`}
            style={{ whiteSpace: 'nowrap' }}
          >
            Thiết lập vị trí ký
          </span>
        </div>
      </div>
    );
  };

  // Component render progress steps (có thể có hoặc không có nút)
  const renderProgressSteps = (showButtons: boolean = true) => (
    <div className="bg-white px-4 py-3 border-bottom-1 border-gray-200">
      <div
        className={`flex align-items-center ${showButtons ? 'justify-content-between' : 'justify-content-center'}`}
        style={{ gap: '12px' }}
      >
        {showButtons && (
          <Button
            label="Quay lại"
            icon="pi pi-arrow-left"
            className="p-button-outlined p-button-secondary"
            onClick={handleCancel}
          />
        )}

        {renderStepIndicators(showButtons)}

        {showButtons && (
          <Button
            label="Tiếp tục"
            icon="pi pi-arrow-right"
            onClick={handleSubmit}
            className="p-button-success"
          />
        )}
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {initializing && <div className="p-4">Đang tải...</div>}
      {/* Progress Steps với nút Quay lại và Tiếp tục - Chỉ hiển thị khi không có dialog nào mở */}
      {!showRecipients && !showSignaturePlacement && renderProgressSteps(true)}

      {/* Main Content */}
      <div className="p-2">
        <div className="max-w-screen-md mx-auto">
          <div className="grid">
            {/* Left Column - Document Information */}
            <div className="col-12 lg:col-3">
              <Card title="Thông tin tài liệu" className="h-full">


                <Divider className="mb-2" />

                {/* Document Marking */}
                <div className="field mb-3">
                  <label className="block text-900 font-medium mb-2">Đánh dấu tài liệu</label>
                  <div className="flex gap-3">
                    <div className="flex align-items-center gap-2">
                      <Checkbox
                        inputId="important"
                        checked={formData.isImportant}
                        onChange={(e) => handleCheckboxChange('isImportant', !!e.checked)}
                        disabled={isViewMode}
                      />
                      <label htmlFor="important" className="text-sm">Quan trọng</label>
                    </div>
                    <div className="flex align-items-center gap-2">
                      <Checkbox
                        inputId="urgent"
                        checked={formData.isUrgent}
                        onChange={(e) => handleCheckboxChange('isUrgent', !!e.checked)}
                        disabled={isViewMode}
                      />
                      <label htmlFor="urgent" className="text-sm">Khẩn cấp</label>
                    </div>
                  </div>
                </div>

                {/* Document Name */}
                <div className="field mb-3">
                  <label htmlFor="agreementName" className="block text-900 font-medium mb-1">
                    Tên tài liệu <span className="text-red-500">(*)</span>
                  </label>
                  {(() => {
                    const shouldShowError = !isViewMode && formData.agreementName.trim() === '' && (validationTriggered || touchedFields.agreementName);
                    return (
                      <>
                        <InputText
                          id="agreementName"
                          value={formData.agreementName}
                          onChange={(e) => handleInputChange('agreementName', e.target.value)}
                          className={shouldShowError ? 'p-invalid' : ''}
                          placeholder="Nhập tên tài liệu"
                          size="small"
                          disabled={isViewMode}
                        />
                        {shouldShowError && (
                          <small className="p-error text-xs">Không được để trống</small>
                        )}
                      </>
                    );
                  })()}
                </div>

                {/* Document Type */}
                <div className="field mb-3">
                  <label htmlFor="agreementType" className="block text-900 font-medium mb-1">
                    Loại tài liệu <span className="text-red-500">(*)</span>
                  </label>
                  <Dropdown
                    id="agreementType"
                    value={formData.agreementType}
                    options={documentTypes}
                    optionLabel="label"
                    optionValue="value"
                    onChange={(e) => handleInputChange('agreementType', e.value)}
                    placeholder="Loại tài liệu"
                    className={`w-full ${formData.agreementType === null ? 'p-invalid' : ''}`}
                    disabled={isViewMode}
                  />
                </div>

                {/* Date Fields */}
                <div className="field mb-3">
                  <div className="grid">
                    <div className="col-12 ">
                      <label htmlFor="effectiveDate" className="block text-900 font-medium mb-1">Ngày hiệu lực</label>
                      <Calendar
                        ref={effectiveDateCalendarRef}
                        id="effectiveDate"
                        value={formData.effectiveDate}
                        onChange={(e) => handleInputChange('effectiveDate', e.value)}
                        placeholder="Chọn thời điểm"
                        showIcon
                        dateFormat="dd/mm/yy"
                        showTime
                        hourFormat="24"
                        showSeconds
                        panelClassName="time-right"
                        style={{ width: '100%' }}
                        maxDate={getEffectiveMaxDate()}
                        disabled={isViewMode}
                        footerTemplate={() => (
                          <div className="flex justify-content-end gap-2 p-2">
                            <Button
                              label="Xác nhận"
                              icon="pi pi-check"
                              onClick={() => {
                                if (effectiveDateCalendarRef.current) {
                                  effectiveDateCalendarRef.current.hide();
                                }
                              }}
                              className="p-button-sm"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-12 ">
                      <label htmlFor="expiryDate" className="block text-900 font-medium mb-1">Ngày hết hiệu lực</label>
                      <Calendar
                        ref={expiryDateCalendarRef}
                        id="expiryDate"
                        value={formData.expiryDate}
                        onChange={(e) => handleInputChange('expiryDate', e.value)}
                        placeholder="Chọn thời điểm"
                        showIcon
                        dateFormat="dd/mm/yy"
                        minDate={getExpiryMinDate()}
                        readOnlyInput
                        showTime
                        hourFormat="24"
                        showSeconds
                        panelClassName="time-right"
                        style={{ width: '100%' }}
                        disabled={isViewMode}
                        footerTemplate={() => (
                          <div className="flex justify-content-end gap-2 p-2">
                            <Button
                              label="Xác nhận"
                              icon="pi pi-check"
                              onClick={() => {
                                if (expiryDateCalendarRef.current) {
                                  expiryDateCalendarRef.current.hide();
                                }
                              }}
                              className="p-button-sm"
                            />
                          </div>
                        )}
                      />
                      {!isViewMode && formData.expiryDate && (() => {
                        const now = new Date();
                        const expiry = new Date(formData.expiryDate as any);
                        const effective = formData.effectiveDate ? new Date(formData.effectiveDate as any) : null;
                        let minExpiryDate = new Date(now.getTime() + 60 * 60 * 1000); // now + 1 giờ
                        if (effective) {
                          const effectivePlusOneHour = new Date(effective.getTime() + 60 * 60 * 1000); // effectiveDate + 1 giờ
                          minExpiryDate = new Date(Math.max(minExpiryDate.getTime(), effectivePlusOneHour.getTime()));
                        }
                        const nowPlusOneHour = new Date(now.getTime() + 60 * 60 * 1000);
                        if (!effective && expiry.getTime() <= nowPlusOneHour.getTime()) {
                          return (
                            <small className="p-error text-xs">
                              Ngày hết hiệu lực phải lớn hơn thời điểm hiện tại ít nhất 1 giờ
                            </small>
                          );
                        }
                        const isInvalid = expiry <= minExpiryDate;
                        return isInvalid ? (
                          <small className="p-error text-xs">
                            Ngày hết hiệu lực phải lớn hơn ngày hiệu lực ít nhất 1 giờ
                          </small>
                        ) : null;
                      })()}
                    </div>
                  </div>
                </div>

                {/* Document Code */}
                <div className="field mb-3">
                  <label htmlFor="agreementNo" className="block text-900 font-medium mb-1">Mã tài liệu <span className="text-red-500">(*)</span></label>
                  <div className="p-inputgroup">
                    <InputText
                      id="documentCode"
                      value={formData.agreementNo}
                      onChange={(e) => handleInputChange('agreementNo', e.target.value)}
                      placeholder="Nhập mã tài liệu"
                      size="small"
                      disabled={isViewMode}
                    />
                    <Button
                      label="Tạo tự động"
                      className="p-button-outlined p-button-sm"
                      onClick={() => generateDocumentCode(formData.agreementType)}
                      size="small"
                      disabled={isViewMode}
                    />
                  </div>
                </div>

                {/* Description */}
                <div className="field mb-3">
                  <label htmlFor="description" className="block text-900 font-medium mb-1">Mô tả</label>
                  <InputTextarea
                    id="description"
                    value={formData.description}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    rows={10}
                    maxLength={500}
                    placeholder="Nhập mô tả tài liệu"
                    className="w-full"
                    disabled={isViewMode}
                  />
                  <small className="text-gray-600 text-xs mt-1">
                    {formData.description.length}/500
                  </small>
                </div>
              </Card>
            </div>

            {/* Right Column - File Management */}
            <div className="col-12 lg:col-9">
              <Card title={`TỆP TÀI LIỆU (${mainFiles.length})`} className="h-full" style={{ paddingBottom: '10px' }}>
                <div className="grid" style={{ paddingTop: '15px' }}>
                  {/* Upload Area */}
                  {!isViewMode && (
                    <div className="col-12 mb-3" style={{ width: '20%' }}>
                      <div className="border-2 border-dashed border-blue-500 border-round p-4 text-center bg-blue-50 h-full">
                        <div className="flex flex-column align-items-center gap-3 h-full justify-content-center">
                          <i className="pi pi-upload text-4xl text-blue-500"></i>
                          <div>
                            <p className="text-gray-700 m-0 font-medium text-sm">Thêm vào tệp của bạn từ</p>
                          </div>
                          <div className="grid w-full">
                            <div className="col-6">
                              <div
                                className={`flex flex-column align-items-center gap-1 p-2 border-1 border-gray-300 border-round transition-all ${mainFiles.length > 0
                                  ? 'cursor-not-allowed opacity-50'
                                  : 'cursor-pointer hover:bg-white hover:shadow-2'
                                  }`}
                                onClick={mainFiles.length > 0 ? undefined : handleComputerUpload}
                              >
                                <i className="pi pi-folder text-xl text-blue-500"></i>
                                <span className="text-xs font-medium text-gray-700">Máy tính</span>
                              </div>
                            </div>
                            <div className="col-6">
                              <div
                                className={`flex flex-column align-items-center gap-1 p-2 border-1 border-gray-300 border-round transition-all ${mainFiles.length > 0
                                  ? 'cursor-not-allowed opacity-50'
                                  : 'cursor-pointer hover:bg-white hover:shadow-2'
                                  }`}
                                onClick={mainFiles.length > 0 ? undefined : handleCreateGoogleFile}
                              >
                                <i className="pi pi-file text-xl text-blue-500"></i>
                                <span className="text-xs font-medium text-gray-700">Soạn mới</span>
                              </div>
                            </div>
                          </div>
                          <div>
                            <small className="text-gray-500 text-xs">Định dạng được hỗ trợ: .pdf, .docx, .doc</small>
                          </div>
                          <Button
                            label="Thêm"
                            icon="pi pi-plus"
                            className="p-button-sm"
                            onClick={handleComputerUpload}
                            disabled={mainFiles.length > 0}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {mainFiles.map((file, index) => (
                    <div key={index} className="col-12 mb-3" style={{ width: '20%' }}>
                      <div className="card p-3 h-full">
                        <div className="flex flex-column h-full">
                          <div className="flex-1 mb-2">
                            <div className="border-1 border-gray-200 border-round p-2 text-center bg-gray-50" style={{ height: '200px' }}>
                              {(() => {
                                const fileKey = `${file.name}-${file.googleFileId}`;
                                const previewUrl = filePreviews[fileKey];
                                const isLoading = previewLoading[fileKey];

                                if (isLoading) {
                                  return (
                                    <div className="flex align-items-center justify-content-center h-full">
                                      <i className="pi pi-spin pi-spinner text-2xl text-blue-500"></i>
                                    </div>
                                  );
                                }

                                if (previewUrl) {
                                  if (file.extension === 'pdf') {
                                    return (
                                      <img
                                        src={previewUrl}
                                        alt="First page preview"
                                        width="100%"
                                        height="100%"
                                        style={{ objectFit: 'contain', borderRadius: '4px' }}
                                      />
                                    );
                                  }
                                }

                                const ic = getIconByExtension(file.extension);
                                return (
                                  <div className="flex align-items-center justify-content-center h-full">
                                    <i className={`${ic.icon} ${ic.color} text-4xl`}></i>
                                  </div>
                                );
                              })()}
                            </div>
                          </div>

                          {/* File Info and Actions */}
                          <div className="flex align-items-center justify-content-between mb-2">
                            <div className="flex align-items-center gap-2">
                              {(() => {
                                const ic = getIconByExtension(file.extension);
                                return <i className={`${ic.icon} ${ic.color}`}></i>;
                              })()}
                              <span className="font-medium text-gray-800 text-sm truncate" title={file.name} style={{ maxWidth: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {file.name}
                              </span>
                            </div>
                            <Menu
                              model={getFileMenuItems(file)}
                              popup
                              ref={(el) => {
                                if (el) {
                                  (file as any).menuRef = el;
                                }
                              }}
                            />
                            <Button
                              icon="pi pi-ellipsis-v"
                              className="p-button-text p-button-sm"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                (file as any).menuRef?.toggle(e);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {formData.agreementType && (
                  <div className="mb-3">
                    <div className="flex justify-content-between align-items-center mb-3">
                      <h6 className="m-0 text-gray-700 font-medium">TỆP ĐÍNH KÈM ({attachedFiles.length})</h6>
                    </div>
                    {documentTypeItemsLoading ? (
                      <div className="flex align-items-center gap-2 mt-1 text-sm text-blue-500">
                        <i className="pi pi-spin pi-spinner" />
                        <span>Đang tải cấu hình...</span>
                      </div>
                    ) : documentTypeItems.length > 0 ? (
                      <div className="border-2 border-dashed border-blue-200 border-round p-2 mt-3" style={{ overflowX: 'auto' }}>
                        <table className="w-full text-sm" style={{ tableLayout: 'fixed', minWidth: '900px' }}>
                          <thead>
                            <tr className="text-left bg-blue-50">
                              <th style={{ width: '50px' }} className="p-2 text-center">#</th>
                              <th style={{ width: '260px' }} className="p-2">Mô tả tài liệu</th>
                              <th style={{ width: '320px' }} className="p-2">Tệp tài liệu</th>
                              <th style={{ width: '165px' }} className="p-2 text-center">Hình thức</th>
                              <th style={{ width: '190px' }} className="p-2 text-center">Ngày nhận</th>
                            </tr>
                          </thead>
                          <tbody>
                            {documentTypeItems.map((item: any, idx: number) => {
                              const seq = resolveConfigItemSeq(item, idx);
                              const seqKey = seq ? String(seq) : `idx-${idx}`;
                              const isRequired =
                                (() => {
                                  const flag = item?.isRequire ?? item?.isRequired ?? item?.required;
                                  return flag === 'Y' || flag === true;
                                })();
                              const meta = documentTypeItemMeta[seqKey] || {};
                              const formType = meta?.formType;
                              const file = attachedFiles.find((f: any) => {
                                const fileSeq = f?.sequenceNum ?? f?.configSequenceNum;
                                return Number(fileSeq) === Number(seq);
                              });
                              return (
                                <tr key={seqKey} className="border-bottom-1 surface-border">
                                  <td className="p-2 text-center font-semibold" style={{ width: '50px' }}>
                                    {seq ?? idx + 1}
                                  </td>
                                  <td className="p-2" style={{ width: '260px' }}>
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        maxWidth: '100%',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                      }}
                                      title={getFileTypeName(item)}
                                    >
                                      {getFileTypeName(item)}
                                      {isRequired && <span className="text-red-500 ml-1">*</span>}
                                    </span>
                                  </td>
                                  <td className="p-2" style={{ width: '320px' }}>
                                    <div
                                      className="flex align-items-center gap-2"
                                      style={{ flexWrap: 'nowrap', width: '100%' }}
                                    >
                                      {!isViewMode && !file && (
                                        <Button
                                          type="button"
                                          label="Chọn tệp"
                                          icon="pi pi-folder"
                                          className="p-button-sm"
                                          style={{ flexShrink: 0, minWidth: '100px' }}
                                          onClick={() => handleDocumentTypeItemUpload(item, idx)}
                                        />
                                      )}
                                      <span
                                        className="text-gray-600"
                                        style={{
                                          display: 'inline-block',
                                          flex: '1 1 auto',
                                          minWidth: 0,
                                          maxWidth: '320px',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis'
                                        }}
                                        title={file ? file.name : 'Không có tệp nào được chọn'}
                                      >
                                        {file ? file.name : 'Không có tệp nào được chọn'}
                                      </span>
                                      {file && (
                                        <div className="flex align-items-center gap-1" style={{ flexShrink: 0 }}>
                                          <Button
                                            type="button"
                                            icon="pi pi-eye"
                                            className="p-button-rounded p-button-text p-button-sm"
                                            tooltip="Xem"
                                            style={{ width: '32px', height: '32px', padding: 0 }}
                                            onClick={() => handleViewFile(file)}
                                          />
                                          {!isViewMode && (
                                            <Button
                                              type="button"
                                              icon="pi pi-trash"
                                              className="p-button-rounded p-button-text p-button-danger p-button-sm"
                                              tooltip="Xóa"
                                              style={{ width: '32px', height: '32px', padding: 0 }}
                                              onClick={() => handleRemoveLocalFile(file)}
                                            />
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="p-2 text-center" style={{ width: '165px' }}>
                                    <Dropdown
                                      value={meta?.formType ?? null}
                                      options={formTypeOptions}
                                      placeholder="Chọn"
                                      className="w-full"
                                      onChange={(e) => handleDocumentTypeItemMetaChange(seqKey, 'formType', e.value)}
                                      disabled={isViewMode}
                                    />
                                  </td>
                                  <td className="p-2 text-center" style={{ width: '190px' }}>
                                    <Calendar
                                      value={meta?.receivedDate ?? null}
                                      onChange={(e) => handleDocumentTypeItemMetaChange(seqKey, 'receivedDate', e.value)}
                                      showIcon
                                      dateFormat="dd/mm/yy"
                                      placeholder="Chọn ngày"
                                      className="w-full"
                                      disabled={isViewMode}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="mt-1 text-sm text-gray-500">
                        Loại tài liệu này chưa có cấu hình file đính kèm.
                      </div>
                    )}
                  </div>
                )}

                <FileUpload
                  ref={fileUploadRef}
                  mode="basic"
                  name="files"
                  accept=".pdf,.docx,.doc"
                  maxFileSize={10000000}
                  customUpload={true}
                  uploadHandler={handleFileUpload}
                  chooseLabel="Chọn tệp"
                  className="hidden"
                />
              </Card>
            </div>
          </div>
        </div>
      </div>
      {/* Recipients Dialog */}
      <Dialog
        header={
          <div className="w-full">
            {renderProgressSteps(false)}
          </div>
        }
        visible={showRecipients}
        style={{ width: '95vw', height: '95vh', maxWidth: 'none' }}
        onHide={() => setShowRecipients(false)}
        footer={
          <div className="flex justify-content-end gap-2">
            <Button
              label="Quay lại"
              icon="pi pi-arrow-left"
              className="p-button-outlined p-button-secondary"
              onClick={() => setShowRecipients(false)}
            />
            <Button
              label="Tiếp tục"
              icon="pi pi-arrow-right"
              className="p-button-success"
              onClick={() => {
                if (validateRecipients()) {
                  setShowRecipients(false);
                  setShowSignaturePlacement(true);
                }
              }}
            />
          </div>
        }
      >
        <div className="p-4">
          <div className="grid mt-3">
            <div className="col-12 flex justify-content-between flex-wrap">
              <b style={{ fontSize: '20px' }}>Người nhận</b>
            </div>
            <div className="col-12">
              {documentRecipients.map((rec, idx) => (
                <div className="col-12 card" style={{ padding: '0.5rem' }} key={idx}>
                  <div className="flex col-12">
                    <div className="col-3 flex flex-column">
                      <label htmlFor="partyId"><b>Đối tượng</b> <span style={{ color: 'red' }}>*</span></label>
                      <div className="p-inputgroup mt-2" style={{ height: '34px' }}>
                        <AutoComplete
                          dropdown
                          field="label"
                          suggestions={getCustomerSuggestionsForRow(idx)}
                          value={rec.party}
                          onChange={(e) => handleRecipientChange(idx, 'party', e.value)}
                          completeMethod={searchCustomers}
                          placeholder="Tìm kiếm đối tượng"
                          disabled={isViewMode}
                        />
                        {!isViewMode && (
                          <span className="p-inputgroup-addon" style={{ background: '#22C55E', color: 'white', cursor: 'pointer' }} onClick={() => createCustomer(idx)}>
                            <i className="pi pi-plus" />
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-column gap-2 col-3">
                      <label htmlFor="taxCode"><b>Mã số thuế</b></label>
                      <InputText
                        id="taxCode"
                        name="taxCode"
                        value={rec.taxCode || ''}
                        onChange={(e) => handleRecipientChange(idx, 'taxCode', e.target.value)}
                        onInput={(e) => {
                          const value = (e.target as HTMLInputElement).value.replace(/[^0-9]/g, '');
                          if (value !== (e.target as HTMLInputElement).value) {
                            (e.target as HTMLInputElement).value = value;
                            handleRecipientChange(idx, 'taxCode', value);
                          }
                        }}
                        onPaste={(e) => {
                          const paste = (e.clipboardData || (window as any).clipboardData).getData('text');
                          if (!/^[0-9]*$/.test(paste)) {
                            e.preventDefault();
                          }
                        }}
                        maxLength={13}
                        pattern="[0-9]*"
                        inputMode="numeric"
                        disabled={isViewMode}
                      />
                    </div>
                    <div className="flex flex-column gap-2 col-3">
                      <label htmlFor="partyName"><b>Tên công ty</b></label>
                      <InputText
                        id="partyName"
                        name="partyName"
                        value={rec.partyName || ''}
                        onInput={(e) => {
                          const inputEl = e.target as HTMLInputElement;
                          const value = inputEl.value.replace(/[^a-zA-ZÀ-ỹ\s-]/g, '');
                          if (value !== inputEl.value) inputEl.value = value;
                        }}
                        onChange={(e) => handleRecipientChange(idx, 'partyName', e.target.value)}
                        pattern="[a-zA-ZÀ-ỹ\s-]+"
                        title="Chỉ được nhập chữ cái và khoảng trắng"
                        disabled={isViewMode}
                      />
                    </div>
                    <div className="flex flex-column gap-2 col-3">
                      <label htmlFor="emailAddress"><b>Email</b> <span style={{ color: 'red' }}>*</span></label>
                      <InputText
                        id="emailAddress"
                        name="emailAddress"
                        value={rec.emailAddress || ''}
                        onChange={(e) => handleRecipientChange(idx, 'emailAddress', e.target.value)}
                        disabled={isViewMode}
                      />
                    </div>
                  </div>
                  <div className="flex col-12">
                    <div className="flex flex-column gap-2 col-3">
                      <label htmlFor="contactNumber"><b>Số điện thoại</b></label>
                      <InputText
                        id="contactNumber"
                        name="contactNumber"
                        value={rec.contactNumber || ''}
                        onInput={(e) => {
                          const value = (e.target as HTMLInputElement).value.replace(/[^0-9]/g, '');
                          (e.target as HTMLInputElement).value = value;
                          handleRecipientChange(idx, 'contactNumber', value);
                        }}
                        onPaste={(e) => {
                          const paste = (e.clipboardData || (window as any).clipboardData).getData('text');
                          if (!/^[0-9]*$/.test(paste)) {
                            e.preventDefault();
                          }
                        }}
                        maxLength={10}
                        pattern="[0-9]*"
                        inputMode="numeric"
                        disabled={isViewMode}
                      />
                    </div>
                    <div className="flex flex-column gap-2 col-3">
                      <label htmlFor="representativeName"><b>Họ và Tên</b></label>
                      <InputText
                        id="representativeName"
                        name="representativeName"
                        value={rec.representativeName || ''}
                        onInput={(e) => {
                          const inputEl = e.target as HTMLInputElement;
                          const value = inputEl.value.replace(/[^a-zA-ZÀ-ỹ\s-]/g, '');
                          if (value !== inputEl.value) inputEl.value = value;
                        }}
                        onChange={(e) => handleRecipientChange(idx, 'representativeName', e.target.value)}
                        onPaste={(e) => {
                          const paste = (e.clipboardData || (window as any).clipboardData).getData('text');
                          if (/[^a-zA-ZÀ-ỹ\s-]/.test(paste)) {
                            e.preventDefault();
                          }
                        }}
                        pattern="[a-zA-ZÀ-ỹ\s-]+"
                        title="Chỉ được nhập chữ cái và khoảng trắng"
                        disabled={isViewMode}
                      />
                    </div>
                    <div className="flex flex-column gap-2 col-3">
                      <label htmlFor="identityCard"><b>CCCD/CMND</b></label>
                      <InputText
                        id="identityCard"
                        name="identityCard"
                        value={rec.identityCard || ''}
                        onInput={(e) => {
                          const value = (e.target as HTMLInputElement).value.replace(/[^0-9]/g, '');
                          const limitedValue = value.slice(0, 12);
                          (e.target as HTMLInputElement).value = limitedValue;
                          handleRecipientChange(idx, 'identityCard', limitedValue);
                        }}
                        onPaste={(e) => {
                          const paste = (e.clipboardData || (window as any).clipboardData).getData('text');
                          if (!/^[0-9]*$/.test(paste)) {
                            e.preventDefault();
                          }
                        }}
                        maxLength={12}
                        pattern="[0-9]*"
                        inputMode="numeric"
                        disabled={isViewMode}
                      />
                    </div>
                    <div className="flex flex-column gap-2 col-3">
                      <label htmlFor="roleTypeId"><b>Vai trò</b> <span style={{ color: 'red' }}>*</span></label>
                      <Dropdown
                        id="roleTypeId"
                        name="roleTypeId"
                        options={getRoleOptionsForRow(idx)}
                        optionLabel="label"
                        optionValue="value"
                        value={rec.roleTypeId}
                        onChange={(e) => handleRecipientChange(idx, 'roleTypeId', e.value)}
                        disabled={isViewMode}
                      />
                    </div>
                  </div>
                  <Button
                    className="mt-1"
                    size="small"
                    onClick={() => removeRecipient(idx)}
                    icon="pi pi-trash"
                    label="Xóa"
                    severity="danger"
                    disabled={documentRecipients.length === 1 || isViewMode}

                  />
                </div>
              ))}
            </div>
            <div className="col-12 flex">
              <Button
                icon="pi pi-plus"
                size="small"
                label="Thêm người nhận"
                onClick={addRecipient}
                disabled={documentRecipients.length >= roleOptions.length || isViewMode}
              />
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        header={
          <div className="w-full">
            {renderProgressSteps(false)}
          </div>
        }
        visible={showSignaturePlacement}
        style={{ width: '95vw', height: '95vh', maxWidth: 'none' }}
        onHide={() => setShowSignaturePlacement(false)}
        footer={
          <div className="flex justify-content-end gap-2">
            <Button
              label="Quay lại"
              icon="pi pi-arrow-left"
              className="p-button-outlined p-button-secondary"
              onClick={() => {
                setShowSignaturePlacement(false);

                setShowRecipients(true);

              }}
            />
            {!isViewMode && (
              <Button
                label="Hoàn thành"
                icon="pi pi-check"
                className="p-button-success"
                onClick={async () => {
                  try {
                    if (!formData.agreementName || !formData.agreementName.trim()) {
                      ToastService.error('Vui lòng nhập Tên tài liệu');
                      return;
                    }
                    if (!formData.agreementType) {
                      ToastService.error('Vui lòng chọn Loại tài liệu');
                      return;
                    }
                    const mainFile = mainFiles.find(f => f.isMainFile);
                    if (!mainFile) {
                      ToastService.error('Không tìm thấy file chính để lưu vị trí ký');
                      return;
                    }

                    const missingSignerPositions = documentRecipients.filter(s => {
                      const sId = s.partyId || s.party?.partyId || s.party?.value;
                      return !signaturePositions.some(p => String(p.partyId) === String(sId));
                    });
                    if (missingSignerPositions.length > 0) {
                      const missingNames = missingSignerPositions
                        .map(s => s.party?.label || s.partyName || s.partyId)
                        .join(', ');
                      ToastService.error(`Vui lòng thêm vị trí ký cho: ${missingNames}`);
                      return;
                    }

                    const normalizedPositions = normalizeLocationSeq(signaturePositions);

                    const formatDateForAPI = (date: Date | null) => {
                      if (!date) return undefined;
                      const d = new Date(date);
                      const year = d.getFullYear();
                      const month = String(d.getMonth() + 1).padStart(2, '0');
                      const day = String(d.getDate()).padStart(2, '0');
                      const hours = String(d.getHours()).padStart(2, '0');
                      const minutes = String(d.getMinutes()).padStart(2, '0');
                      const seconds = String(d.getSeconds()).padStart(2, '0');
                      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
                    };

                    const mainFilesArray = mainFiles.map(file => ({
                      agreementContentId: file.agreementContentId || undefined,
                      fileName: file.name,
                      fileId: file.googleFileId || file.fileId || file.id,
                      contentType: file.type,
                      contentLocation: file.googleFileUrl || file.contentLocation || undefined
                    }));

                    // Tạo attachmentFiles array
                    const attachmentFilesArray = attachedFiles
                      .filter(file => file.sequenceNum !== null && file.sequenceNum !== undefined)
                      .map(file => {
                        const seqKey = String(file.sequenceNum);
                        const meta = documentTypeItemMeta[seqKey] || {};
                        const receivedDateValue =
                          meta?.receivedDate ??
                          (file.agreementFormDate ? new Date(file.agreementFormDate) : null);
                        const selectedFormType =
                          meta?.formType ??
                          normalizeFormTypeValue(file.agreementFormTypeEnumId) ??
                          null;
                        return {
                          agreementContentId: file.agreementContentId || undefined,
                          fileName: file.name,
                          fileId: file.googleFileId || file.fileId || file.id,
                          contentType: file.type,
                          contentLocation: file.googleFileUrl || file.contentLocation || undefined,
                          sequenceNum: file.sequenceNum,
                          agreementFormTypeEnumId: selectedFormType || file.agreementFormTypeEnumId || null,
                          agreementFormDate: receivedDateValue ? formatDateForAPI(receivedDateValue) : (file.agreementFormDate ? formatDateForAPI(new Date(file.agreementFormDate)) : undefined)
                        };
                      });

                    // Tạo agreementParties array
                    const agreementPartiesArray = documentRecipients.map((rec: any) => ({
                      partyId: rec.partyId || rec.party?.partyId || rec.party?.value,
                      roleTypeId: rec.roleTypeId,
                      statusId: rec.statusId || 'AGT_PTY_UNSIGNED'
                    }));

                    // Tạo signaturePositions array
                    const positions = normalizedPositions.map(pos => {
                      const pageIdx = Number(pos.pageIndex);
                      const canvas = canvasRefs.current[pageIdx];
                      const pageWidth = canvas?.width || 0;
                      const pageHeight = canvas?.height || 0;
                      const widthPx = Number(pos.widthPx);
                      const heightPx = Number(pos.heightPx);
                      const fontSize = Number(pos.fontSize);
                      const x = Number(pos.x);
                      const y = Number(pos.y);

                      // Tìm thông tin party đầy đủ từ documentRecipients
                      const partyId = pos.partyId || selectedSigner?.partyId || selectedSigner?.value;
                      const recipient = documentRecipients.find((r: any) =>
                        r.partyId === partyId ||
                        r.party?.partyId === partyId ||
                        r.party?.value === partyId
                      );

                      // Lấy toàn bộ thông tin party
                      const partyInfo = recipient?.party || {};
                      return {
                        locationSeqId: pos.locationSeqId,
                        partyId: partyId,
                        roleTypeId: pos.roleTypeId || recipient?.roleTypeId || selectedSigner?.roleTypeId || null,
                        signatureTypeEnumId: pos.signatureTypeEnumId || 'AgtDigitalVerified',
                        pageNumber: pageIdx + 1,
                        pageWidth: pageWidth,
                        pageHeight: pageHeight,
                        widthPx: widthPx,
                        heightPx: heightPx,
                        ulx: x,
                        uly: y,
                        fontSize: fontSize,
                        partyName: recipient?.partyName || pos.partyName || partyInfo.partyName || '',
                        identityCard: recipient?.identityCard || partyInfo.idValue || partyInfo.identityCard || '',
                        emailAddress: recipient?.emailAddress || partyInfo.emailAddress || '',
                        taxCode: recipient?.taxCode || partyInfo.partyTaxId || partyInfo.taxCode || '',
                        contactNumber: recipient?.contactNumber || partyInfo.contactNumber || '',
                        representativeName: recipient?.representativeName || partyInfo.representativeName || ''
                      };
                    });

                    const signatureData = {
                      agreementName: formData.agreementName,
                      agreementNo: formData.agreementNo || undefined,
                      agreementConfigureEnumId: formData.agreementType,
                      description: formData.description || undefined,
                      fromDate: formatDateForAPI(formData.effectiveDate as Date | null),
                      thruDate: formatDateForAPI(formData.expiryDate as Date | null),
                      isImportant: formData.isImportant ? 'Y' : 'N',
                      isUrgent: formData.isUrgent ? 'Y' : 'N',
                      mainFiles: mainFilesArray,
                      attachmentFiles: attachmentFilesArray,
                      agreementParties: agreementPartiesArray,
                      signaturePositions: positions
                    };
                    const res = await AgreementService.saveSignaturePositions(agreementId as string, signatureData);
                    if (res && res.success === 'Y') {
                      ToastService.success('Tài liệu đã được tạo thành công!');
                      setShowSignaturePlacement(false);
                      try {
                        if (typeof window !== 'undefined' && window.localStorage) {
                          window.localStorage.setItem('econtract.taiLieuKy.activeTab', '0');
                        }
                      } catch (err) {
                      }
                      navigate('/quan-ly-tai-lieu/danh-sach-tai-lieu');
                    } else {
                      ToastService.error(res?.errorMessage || 'Không thể lưu vị trí ký');
                    }
                  } catch (e) {
                    ToastService.error('Có lỗi xảy ra khi lưu vị trí ký');
                  }
                }}
              />
            )}
          </div>
        }
      >
        <div className="flex h-full">
          <div className="col-3 card block">
            <div className="mb-3">
              <label className="block text-900 font-medium mb-2">Chọn người ký</label>
              <Dropdown
                style={{ width: '100%' }}
                optionLabel="label"
                options={documentRecipients.map(r => ({
                  value: r.party?.partyId,
                  partyId: r.party?.partyId,
                  roleTypeId: r.roleTypeId,
                  label: r.party?.label || r.partyName || 'Chưa chọn đối tượng'
                }))}
                value={selectedSigner?.partyId ? selectedSigner.partyId : selectedSigner}
                onChange={(e) => {
                  const opt = documentRecipients.map(r => ({ value: r.party?.partyId, partyId: r.party?.partyId, roleTypeId: r.roleTypeId, label: r.party?.label || r.partyName })).find(o => o.value === e.value) || e.value;
                  setSelectedSigner(opt as any);
                }}
                placeholder="Chọn người ký"
                disabled={isViewMode}
              />
            </div>

            <Divider type="solid" />

            {selectedSigner && !isViewMode && (
              <div className="mt-3">
                <span className="block font-medium mb-3">
                  <b>(Chọn loại chữ ký và kéo thả vào vị trí cần ký)</b>
                </span>
                <Button
                  icon="pi pi-plus"
                  label="Ký điện tử"
                  severity="danger"
                  className="col-12 mb-3"
                  draggable
                  onDragStart={(event) => {
                    event.dataTransfer.setData('text/plain', 'electronic-signature');
                  }}
                />
              </div>
            )}
            {signaturePositions.map((position, index) => (
              <div key={index} className="mb-3" style={isViewMode ? { pointerEvents: 'none', opacity: 0.6 } : {}}>
                <b style={{ fontSize: '14px' }}>Vị trí {index + 1}: {position.label}</b>
                <div className="flex">
                  <div className="flex flex-column col-4">
                    <label className="text-sm">Chiều rộng</label>
                    {(() => {
                      const pageIdx = position.pageIndex || 0;
                      const canvas = pageCanvases && pageCanvases[pageIdx] ? pageCanvases[pageIdx] : (pageCanvases && pageCanvases[0]);
                      const maxW = canvas ? Math.max(0, Math.floor(canvas.width - (position.x || 0))) : undefined;
                      return (
                        <InputText
                          type="number"
                          value={position.widthPx || 200}
                          min={0}
                          max={maxW}
                          onChange={(e) => {
                            const newPositions = [...signaturePositions];
                            const raw = parseInt(e.target.value);
                            const desired = Math.max(raw || 0, 0);
                            const pageIdx = position.pageIndex || 0;
                            const canvas = pageCanvases && pageCanvases[pageIdx] ? pageCanvases[pageIdx] : (pageCanvases && pageCanvases[0]);
                            if (canvas) {
                              const currentX = position.x || 0;
                              const canvasW = canvas.width || 0;
                              const desiredWidth = Math.min(desired, canvasW);
                              if (currentX + desiredWidth > canvasW) {
                                const newX = Math.max(0, canvasW - desiredWidth);
                                newPositions[index].x = newX;
                                newPositions[index].widthPx = Math.max(0, canvasW - newX);
                              } else {
                                newPositions[index].widthPx = desiredWidth;
                              }
                            } else {
                              newPositions[index].widthPx = desired;
                            }
                            setSignaturePositions(normalizeLocationSeq(newPositions));
                          }}
                          size="small"
                          disabled={isViewMode}
                        />
                      )
                    })()}
                  </div>
                  <div className="flex flex-column col-4">
                    <label className="text-sm">Chiều cao</label>
                    {(() => {
                      const pageIdx = position.pageIndex || 0;
                      const canvas = pageCanvases && pageCanvases[pageIdx] ? pageCanvases[pageIdx] : (pageCanvases && pageCanvases[0]);
                      const maxH = canvas ? Math.max(0, Math.floor(canvas.height - (position.y || 0))) : undefined;
                      return (
                        <InputText
                          type="number"
                          value={position.heightPx || 65}
                          min={0}
                          max={maxH}
                          onChange={(e) => {
                            const newPositions = [...signaturePositions];
                            const raw = parseInt(e.target.value);
                            const pageIdx = position.pageIndex || 0;
                            const canvas = pageCanvases && pageCanvases[pageIdx] ? pageCanvases[pageIdx] : (pageCanvases && pageCanvases[0]);
                            if (canvas) {
                              const maxHeight = Math.max(0, Math.floor(canvas.height - (position.y || 0)));
                              newPositions[index].heightPx = Math.min(Math.max(raw || 0, 0), maxHeight);
                            } else {
                              newPositions[index].heightPx = Math.max(raw || 0, 0);
                            }
                            setSignaturePositions(normalizeLocationSeq(newPositions));
                          }}
                          size="small"
                          disabled={isViewMode}
                        />
                      )
                    })()}
                  </div>
                  <div className="flex flex-column col-4">
                    <label className="text-sm">Cỡ chữ</label>
                    <InputText
                      type="number"
                      value={position.fontSize || 12}
                      onChange={(e) => {
                        const newPositions = [...signaturePositions];
                        newPositions[index].fontSize = parseInt(e.target.value);
                        setSignaturePositions(normalizeLocationSeq(newPositions));
                      }}
                      size="small"
                      disabled={isViewMode}
                    />
                  </div>
                </div>
                {!isViewMode && (
                  <Button
                    icon="pi pi-times"
                    text
                    outlined
                    severity="danger"
                    size="small"
                    onClick={() => removeSignaturePosition(position.locationSeqId)}
                  />
                )}
              </div>
            ))}
          </div>

          {/* Right Content - Document Preview */}
          <div className="col-7 align-items-center justify-content-center" style={{ backgroundColor: 'whitesmoke', height: 'calc(100vh - 220px)' }}>
            <div>
              {canvasLoading && (
                <div className="text-center p-4">
                  <i className="pi pi-spin pi-spinner text-2xl"></i>
                  <p>Đang tải PDF...</p>
                </div>
              )}

              {!canvasLoading && pageCanvases.length > 0 && (
                <ScrollPanel style={{ width: '100%', height: 'calc(100vh - 240px)' }}>
                  {pageCanvases.map((canvas, index) => (
                    <div
                      key={index}
                      data-page-index={index}
                      style={{ position: 'relative', marginBottom: '20px' }}
                      onDrop={(event) => handleDrop(event, index)}
                      onDragOver={(event) => event.preventDefault()}
                    >
                      <canvas ref={ref => {
                        if (ref && canvas) {
                          const context = ref.getContext('2d');
                          if (context) {
                            ref.width = canvas.width;
                            ref.height = canvas.height;
                            context.drawImage(canvas, 0, 0);
                            canvasRefs.current[index] = ref;
                          }
                        }
                      }}></canvas>

                      {signaturePositions
                        .filter(element => element.pageIndex === index)
                        .map((element) => (
                          (() => {
                            const nref = draggableRefs.current[element.locationSeqId] || (draggableRefs.current[element.locationSeqId] = React.createRef()); return (
                              <Draggable
                                nodeRef={nref}
                                key={element.locationSeqId}
                                defaultPosition={{ x: element.x || 0, y: element.y || 0 }}
                                bounds={{
                                  left: 0,
                                  top: 0,
                                  right: Math.max(0, canvas.width - element.widthPx),
                                  bottom: Math.max(0, canvas.height - element.heightPx)
                                }}
                                disabled={isViewMode}
                                onStop={(event, data) => handleDragStop(event, data, element.locationSeqId)}
                              >
                                <div style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  background: 'rgb(255,255,255)',
                                  padding: '5px',
                                  borderRadius: '5px',
                                  cursor: isViewMode ? 'default' : 'move',
                                  borderColor: 'red',
                                  borderStyle: 'dashed',
                                  height: element.heightPx,
                                  width: element.widthPx
                                }} ref={nref} className={'flex'}>
                                  <div ref={nref} className={'col-11'} style={{ fontSize: element.fontSize, padding: 0 }}>
                                    -Ký bởi: {element.partyName}<br />
                                    - Ký ngày: dd/MM/yyyy
                                  </div>
                                </div>
                              </Draggable>
                            );
                          })()
                        ))}
                    </div>
                  ))}
                </ScrollPanel>
              )}

              {!canvasLoading && pageCanvases.length === 0 && (
                <div className="p-4 text-center">
                  <i className="pi pi-file-pdf text-6xl text-gray-400 mb-3"></i>
                  <p className="text-gray-500">Chưa có file PDF để hiển thị</p>
                  <small className="text-gray-400">Vui lòng thêm file PDF vào phần "TỆP TÀI LIỆU"</small>
                </div>
              )}
            </div>
          </div>
          <div className="col-2 card" style={{ height: 'calc(100vh - 220px)' }}>
            <div className="p-3">
              {canvasLoading ? (
                <div className="text-center">
                  <i className="pi pi-spin pi-spinner text-2xl"></i>
                  <p className="text-sm mt-2">Đang tải...</p>
                </div>
              ) : pageCanvases.length > 0 ? (
                <div className="flex flex-column gap-2">
                  {pageCanvases.map((canvas, index) => (
                    <div
                      key={index}
                      className="cursor-pointer transition-all hover:bg-blue-50"
                      onClick={() => {
                        const pageElement = document.querySelector(`[data-page-index="${index}"]`);
                        if (pageElement) {
                          pageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                      }}
                    >
                      <div style={{ height: '280px', overflow: 'hidden', position: 'relative', width: '100%' }}>
                        <img
                          src={canvas.toDataURL('image/png')}
                          alt={`${index + 1}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '4px'
                          }}
                        />
                      </div>

                      {/* Page Number */}
                      <div className="p-2 text-center border-top-1 border-gray-200">
                        <div className="text-lg  mb-1" style={{ color: index === 0 ? '#1976d2' : '#666' }}>
                          {index + 1}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center text-gray-500">
                  <i className="pi pi-file text-3xl mb-2"></i>
                  <p className="text-sm">Chưa có trang nào</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </Dialog>

      {/* File Viewer Dialog */}
      <Dialog
        header={
          <div className="flex justify-content-between align-items-center w-full">
            <div className="flex align-items-center gap-3">
              <span className="font-semibold text-lg">{selectedFile?.name || ''}</span>
              {/* Removed page navigation */}
            </div>
            {/* Removed zoom controls */}
          </div>
        }
        visible={showFileViewer}
        style={{ width: '95vw', height: '95vh', maxWidth: 'none' }}
        onHide={() => setShowFileViewer(false)}
        footer={
          <div className="flex justify-content-between align-items-center w-full">
            <div className="flex align-items-center gap-2">
            </div>
            <div className="flex align-items-center gap-2">
              <Button
                icon="pi pi-times"
                label="Đóng"
                className="p-button-outlined p-button-secondary p-button-sm"
                onClick={() => setShowFileViewer(false)}
              />
            </div>
          </div>
        }
      >
        {selectedFile && (
          <div className="flex h-full">
            <div className="flex-1 pl-3">
              {(() => {

                return (
                  viewerUrl ? (
                    <div className="h-full flex flex-column">
                      <div className="flex-1 border-1 border-gray-300 border-round overflow-hidden">
                        <iframe
                          src={`${viewerUrl}#page=${currentPage}&zoom=${Math.round(pdfScale * 100)}`}
                          width="100%"
                          height="100%"
                          style={{ border: 'none' }}
                          title={`PDF Viewer - ${selectedFile.name}`}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="flex align-items-center justify-content-center h-full">
                      <div className="text-center">
                        <i className="pi pi-spin pi-spinner text-4xl text-blue-500 mb-3"></i>
                        <p className="text-lg">Đang tải PDF...</p>
                        <small className="text-gray-500">Vui lòng chờ trong giây lát</small>
                      </div>
                    </div>
                  )
                );
              })()}
            </div>
          </div>
        )}
      </Dialog>

      <EditorDialog
        display={displayEditor}
        setDisplay={setDisplayEditor}
        agreementId={agreementId}
        showRecipients={showRecipients}
        setShowRecipients={setShowRecipients}
        validateRecipients={validateRecipients}
        setMainFiles={setMainFiles}
        setAttachedFiles={setAttachedFiles}
      />
      {customerDialog.render()}
      {/* Delete Main File Confirm Dialog */}
      <Dialog
        header="Xác nhận xóa file ký"
        visible={showDeleteMainFileDialog}
        style={{ width: '32rem' }}
        onHide={() => {
          setShowDeleteMainFileDialog(false);
          setFileToDelete(null);
        }}
        footer={(
          <div className="flex justify-content-end gap-2">
            <Button
              label="Hủy"
              icon="pi pi-times"
              className="p-button-outlined p-button-secondary p-button-sm"
              onClick={() => {
                setShowDeleteMainFileDialog(false);
                setFileToDelete(null);
              }}
            />
            <Button
              label="Xóa"
              icon="pi pi-trash"
              className="p-button-danger p-button-sm"
              onClick={confirmDeleteMainFile}
            />
          </div>
        )}
      >
        <div className="flex flex-column gap-3">
          <div className="flex align-items-center gap-2">
            <i className="pi pi-exclamation-triangle text-orange-500 text-2xl"></i>
            <span className="font-semibold text-lg">Cảnh báo quan trọng</span>
          </div>
          <p className="m-0">
            Bạn có chắc chắn muốn xóa file ký <strong>{fileToDelete?.name}</strong>?
          </p>
          <div className="bg-orange-50 border-left-3 border-orange-500 p-3">
            <p className="m-0 text-sm">
              <i className="pi pi-info-circle text-orange-500 mr-2"></i>
              <strong>Lưu ý:</strong> Khi xóa file ký, tất cả các cấu hình đằng sau sẽ bị xóa hết, bao gồm:
            </p>
            <ul className="mt-2 mb-0 ml-4 text-sm">
              <li>Vị trí ký đã đặt</li>
              <li>Danh sách người ký</li>
            </ul>
          </div>
        </div>
      </Dialog>

      {/* Leave Page Confirm Dialog */}
      <Dialog
        header="Xác nhận rời trang"
        visible={showLeavePrompt}
        style={{ width: '32rem' }}
        onHide={() => setShowLeavePrompt(false)}
        footer={(
          <div className="flex justify-content-end gap-2">
            <Button
              label="Ở lại trang"
              icon="pi pi-times"
              className="p-button-outlined p-button-secondary p-button-sm"
              onClick={() => setShowLeavePrompt(false)}
            />
            <Button
              label="Rời trang"
              icon="pi pi-check"
              className="p-button-danger p-button-sm"
              onClick={() => {
                setShowLeavePrompt(false);
                setHasUnsavedChanges(false);
                if (pendingHash) {
                  window.location.hash = pendingHash;
                }
              }}
            />
          </div>
        )}
      >
        <div className="p-2">
          Bạn có thay đổi chưa lưu. Rời trang sẽ mất các thay đổi. Tiếp tục?
        </div>
      </Dialog>
      {fileOperationLoading && (
        <div
          className="fixed top-0 left-0 w-full h-full flex align-items-center justify-content-center"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)', zIndex: 1500 }}
        >
          <div className="surface-card p-4 border-round flex align-items-center gap-3 shadow-5">
            <i className="pi pi-spin pi-spinner text-2xl text-primary"></i>
            <span className="text-lg font-semibold">Đang xử lý tệp, vui lòng đợi...</span>
          </div>
        </div>
      )}
    </div>
  );
};
const EditorDialog = ({ display, setDisplay, agreementId, showRecipients, setShowRecipients, validateRecipients, setMainFiles, setAttachedFiles }: any) => {
  const [fileId, setFileId] = useState<any>(false);
  const [fileName, setFileName] = useState<string>('');

  React.useEffect(() => {
    if (display?.fileId) {
      setFileId(display.fileId);
      if (display.fileName) {
        setFileName(display.fileName);
      }
    }
  }, [display]);

  const handleSaveFile = async () => {
    if (!fileId) return;
    if (!fileName || !fileName.trim()) {
      ToastService.error('Vui lòng nhập tên tài liệu');
      return;
    }

    try {
      const res = await AgreementService.saveFile(fileId, fileName.trim());
      if (res && res.success === 'Y') {
        const mappedMain = ({
          name: fileName.trim(),
          size: 0,
          type: 'application/vnd.google-apps.document',
          file: undefined,
          extension: 'docx',
          googleFileId: fileId,
          fileId: fileId,
          id: fileId,
          // fileId đã có nên không cần tempId
          googleFileUrl: `https://docs.google.com/document/d/${fileId}/edit`,
          isMainFile: true
        });
        setMainFiles([mappedMain]);
        setTimeout(() => setDisplay(false), 0);


      } else {
        ToastService.error(res?.error || 'Không thể lưu tài liệu');
      }
      ToastService.success(`Tài liệu đã được lưu thành công!`);
    } catch (e: any) {
      ToastService.error('Error saving file');
    }
  }
  return (
    <Dialog
      header="Editor"
      visible={!!display}
      style={{ width: '98vw' }}
      position="top"
      onHide={() => setDisplay(false)}
      footer={(
        <div className="flex justify-content-end gap-2">
          <span className="p-inputgroup" style={{ maxWidth: 360 }}>
            <span className="p-inputgroup-addon"><i className="pi pi-file" /></span>
            <InputText value={fileName} onChange={(e) => setFileName(e.target.value)} placeholder="Nhập tên tài liệu" />
          </span>
          <Button label="Lưu tài liệu" icon="pi pi-save" type="button" severity="success" size="small" onClick={() => handleSaveFile()} />
          <Button label="Đóng" icon="pi pi-times" type="button" outlined severity="secondary" size="small" onClick={() => setDisplay(false)} />
        </div>
      )}
    >
      {fileId && (
        <iframe
          src={`https://docs.google.com/document/d/${fileId}/edit`}
          width="100%"
          height="800"
          style={{ border: 'none' }}
          referrerPolicy="no-referrer"
        ></iframe>
      )}
    </Dialog>
  );
};